import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
export type DeleteCobraParticipantMutationVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type DeleteCobraParticipantMutation = { __typename?: 'Mutation', deleteCobraCensus?: { __typename?: 'DeleteCobraCensusPayload', uuid?: string | null } | null };

export type GetCobraParticipantsQueryVariables = Exact<{
  uuid: Scalars['ID'];
  appType: ApplicationTypeEnum;
}>;


export type GetCobraParticipantsQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', healthInsuranceInformation?: { __typename?: 'CompanyHealthInsuranceInfo', cobraUsage?: boolean | null, currentlyOfferHealthInsurance?: boolean | null } | null, applications?: Array<{ __typename?: 'Application', uuid: string, step?: number | null }> | null, cobraCensuses?: Array<{ __typename?: 'CobraCensus', uuid: string, firstName: string, lastName: string, participantType: ParticipantTypeEnum, gender: GenderTypeEnum, dateOfBirth?: any | null, homeZip: string, cobraDependents?: Array<{ __typename?: 'CobraCensus', uuid: string, firstName: string, lastName: string, participantType: ParticipantTypeEnum, gender: GenderTypeEnum, dateOfBirth?: any | null, homeZip: string, healthInsInfo?: { __typename?: 'HealthInsuranceInfo', currentEnrollmentTier?: PlanTierEnum | null, currentMonthlyPremium?: number | null, currentPlanName?: string | null, monthlyPremiumPostRenewal?: number | null } | null }> | null, healthInsInfo?: { __typename?: 'HealthInsuranceInfo', currentEnrollmentTier?: PlanTierEnum | null, currentMonthlyPremium?: number | null, currentPlanName?: string | null, monthlyPremiumPostRenewal?: number | null } | null }> | null } | null };

export type UpsertCobraParticipantsMutationVariables = Exact<{
  prospectId: Scalars['ID'];
  cobraCensuses: Array<CobraCensusInput> | CobraCensusInput;
}>;


export type UpsertCobraParticipantsMutation = { __typename?: 'Mutation', upsertCobraCensus?: { __typename?: 'UpsertCobraCensusPayload', uuids?: Array<string> | null } | null };

export type CreateDependentCensusesMutationVariables = Exact<{
  dependentCensuses: Array<DependentCensusInput> | DependentCensusInput;
  prospectId: Scalars['ID'];
}>;


export type CreateDependentCensusesMutation = { __typename?: 'Mutation', createDependentCensuses?: { __typename?: 'CreateDependentCensusesPayload', uuids?: Array<string> | null } | null };

export type DeleteDependentCensusMutationVariables = Exact<{
  uuid: Scalars['ID'];
  participantType: ParticipantTypeEnum;
}>;


export type DeleteDependentCensusMutation = { __typename?: 'Mutation', deleteDependentCensus?: { __typename?: 'DeleteDependentCensusPayload', uuid?: string | null } | null };

export type DeleteMdvDependentCensusMutationVariables = Exact<{
  uuids: Array<Scalars['ID']> | Scalars['ID'];
  prospectId: Scalars['ID'];
}>;


export type DeleteMdvDependentCensusMutation = { __typename?: 'Mutation', deleteDependentCensuses?: { __typename?: 'DeleteDependentCensusesPayload', uuids?: Array<string> | null } | null };

export type GetCurrentEmployeesQueryVariables = Exact<{
  uuid: Scalars['ID'];
  appType: ApplicationTypeEnum;
}>;


export type GetCurrentEmployeesQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', healthInsuranceInformation?: { __typename?: 'CompanyHealthInsuranceInfo', cobraUsage?: boolean | null, currentlyOfferHealthInsurance?: boolean | null } | null, applications?: Array<{ __typename?: 'Application', uuid: string, status?: ApplicationStatusEnum | null, step?: number | null }> | null, workersCompApplication?: Array<{ __typename?: 'Application', status?: ApplicationStatusEnum | null, uuid: string }> | null, employeeCensuses?: Array<{ __typename?: 'EmployeeCensus', uuid: string, source?: EmployeeCensusSourceEnum | null, firstName: string, lastName: string, gender?: GenderTypeEnum | null, dateOfBirth?: any | null, email: string, homeZip?: string | null, homeState?: string | null, isCompanyOwner?: boolean | null, isCompanyEmployee?: boolean | null, employeeInformation?: { __typename?: 'EmployeeInformation', department?: string | null, isPaid?: string | null } | null, healthInsInfo?: { __typename?: 'HealthInsuranceInfo', currentPlanName?: string | null, currentEnrollmentTier?: PlanTierEnum | null, currentMonthlyPremium?: number | null, monthlyPremiumPostRenewal?: number | null, isWaiving?: boolean | null } | null, dependentCensuses?: Array<{ __typename?: 'DependentCensus', employeeCensusId: string, uuid: string, firstName: string, lastName: string, gender: GenderTypeEnum, dateOfBirth: any, homeZip: string, homeState?: string | null, participantType: string }> | null }> | null } | null };

export type UpsertDependentAndEmployeeCensusMutationVariables = Exact<{
  prospectId: Scalars['ID'];
  dependentCensuses: Array<DependentCensusInput> | DependentCensusInput;
  source?: InputMaybe<EmployeeCensusSourceEnum>;
}>;


export type UpsertDependentAndEmployeeCensusMutation = { __typename?: 'Mutation', upsertDependentAndEmployeeCensus?: { __typename?: 'UpsertDependentAndEmployeeCensusPayload', uuids?: Array<string> | null } | null };

export type UpdateDependentCensusesMutationVariables = Exact<{
  dependentCensuses: Array<DependentCensusInput> | DependentCensusInput;
  prospectId: Scalars['ID'];
}>;


export type UpdateDependentCensusesMutation = { __typename?: 'Mutation', updateDependentCensuses?: { __typename?: 'UpdateDependentCensusesPayload', uuids?: Array<string> | null } | null };

export type GetCurrentInsuranceQueryVariables = Exact<{
  uuid: Scalars['ID'];
  appType: ApplicationTypeEnum;
}>;


export type GetCurrentInsuranceQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', yearFounded?: number | null, sicCode?: string | null, dba?: string | null, companyName: string, healthInsuranceApplication?: Array<{ __typename?: 'Application', step?: number | null, uuid: string, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, workersCompApplication?: Array<{ __typename?: 'Application', step?: number | null, uuid: string }> | null, healthInsuranceInformation?: { __typename?: 'CompanyHealthInsuranceInfo', cobraUsage?: boolean | null, currentlyOfferHealthInsurance?: boolean | null, currentRenewalDate?: any | null, controlledGroup?: boolean | null, startingCoverageDate?: any | null, isOnPeo?: boolean | null, currentPeo?: string | null, currentPeoOther?: string | null } | null } | null };

export type UpdateCurrentInsuranceMutationVariables = Exact<{
  uuid: Scalars['ID'];
  controlledGroup?: InputMaybe<Scalars['Boolean']>;
  startingCoverageDate?: InputMaybe<Scalars['ISO8601Date']>;
  isOnPeo?: InputMaybe<Scalars['Boolean']>;
  currentPeo?: InputMaybe<Scalars['String']>;
  currentPeoOther?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCurrentInsuranceMutation = { __typename?: 'Mutation', updateProspectHealthInsuranceInfo?: { __typename?: 'UpdateProspectHealthInsuranceInfoPayload', uuid?: string | null } | null };

export type UpdateProspectInfoMutationVariables = Exact<{
  uuid: Scalars['ID'];
  yearFounded?: InputMaybe<Scalars['Int']>;
  sicCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  dba?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProspectInfoMutation = { __typename?: 'Mutation', updateBaseProspect?: { __typename?: 'UpdateBaseProspectPropertiesPayload', uuid?: string | null } | null };

export type CreateHealthApplicationMutationVariables = Exact<{
  prospectId: Scalars['ID'];
  appType: ApplicationTypeEnum;
  prospectCanonicalId?: InputMaybe<Scalars['String']>;
  memberUuid?: InputMaybe<Scalars['ID']>;
  applicationSteps?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateHealthApplicationMutation = { __typename?: 'Mutation', createApplication?: { __typename?: 'CreateApplicationPayload', uuid?: string | null } | null };

export type GetHealthAppStepQueryVariables = Exact<{
  uuid: Scalars['ID'];
  appType: ApplicationTypeEnum;
}>;


export type GetHealthAppStepQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', healthInsuranceInformation?: { __typename?: 'CompanyHealthInsuranceInfo', isCoverageEligible?: boolean | null, cobraUsage?: boolean | null, currentlyOfferHealthInsurance?: boolean | null } | null, applications?: Array<{ __typename?: 'Application', uuid: string, step?: number | null, status?: ApplicationStatusEnum | null, flowVersion?: string | null, createdAt: any, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, cobraCensuses?: Array<{ __typename?: 'CobraCensus', firstName: string, lastName: string }> | null } | null };

export type GetCurrentCoverageQueryVariables = Exact<{
  uuid: Scalars['ID'];
  appType: ApplicationTypeEnum;
}>;


export type GetCurrentCoverageQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', sicCode?: string | null, healthInsuranceInformation?: { __typename?: 'CompanyHealthInsuranceInfo', isCoverageEligible?: boolean | null, currentlyOfferHealthInsurance?: boolean | null, currentCarrier?: HealthcareCarrierTypeEnum | null, currentCarrierOther?: string | null, currentRenewalDate?: any | null, cobraUsage?: boolean | null, cobraUsers?: number | null, benefitEligibleEmployees?: number | null, controlledGroup?: boolean | null, isOnPeo?: boolean | null, currentPeo?: string | null, currentPeoOther?: string | null, startingCoverageDate?: any | null } | null, applications?: Array<{ __typename?: 'Application', uuid: string, step?: number | null }> | null } | null };

export type UpdateCurrentCoverageMutationVariables = Exact<{
  uuid: Scalars['ID'];
  benefitEligibleEmployees?: InputMaybe<Scalars['Int']>;
  cobraUsage?: InputMaybe<Scalars['Boolean']>;
  cobraUsers?: InputMaybe<Scalars['Int']>;
  currentCarrier?: InputMaybe<HealthcareCarrierTypeEnum>;
  currentCarrierOther?: InputMaybe<Scalars['String']>;
  currentRenewalDate?: InputMaybe<Scalars['ISO8601Date']>;
  currentlyOfferHealthInsurance?: InputMaybe<Scalars['Boolean']>;
  isOnPeo?: InputMaybe<Scalars['Boolean']>;
  currentPeo?: InputMaybe<Scalars['String']>;
  currentPeoOther?: InputMaybe<Scalars['String']>;
  controlledGroup?: InputMaybe<Scalars['Boolean']>;
  startingCoverageDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type UpdateCurrentCoverageMutation = { __typename?: 'Mutation', updateProspectHealthInsuranceInfo?: { __typename?: 'UpdateProspectHealthInsuranceInfoPayload', uuid?: string | null, isCoverageEligible?: boolean | null, cobraUsage?: boolean | null, currentlyOfferHealthInsurance?: boolean | null } | null };

export type GetPrimaryAddressQueryVariables = Exact<{
  uuid: Scalars['ID'];
  appType: ApplicationTypeEnum;
}>;


export type GetPrimaryAddressQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', healthInsuranceInformation?: { __typename?: 'CompanyHealthInsuranceInfo', isCoverageEligible?: boolean | null } | null, applications?: Array<{ __typename?: 'Application', uuid: string, step?: number | null, createdAt: any }> | null, officeLocations?: Array<{ __typename?: 'OfficeLocation', address1: string, address2?: string | null, city: string, locationName?: string | null, state: string, zip: string, autoValidated?: boolean | null, uuid: string, isHq: boolean, subdivision?: string | null }> | null } | null };

export type GetCoverageEligibilityQueryVariables = Exact<{
  uuid: Scalars['ID'];
  appType: ApplicationTypeEnum;
}>;


export type GetCoverageEligibilityQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', healthInsuranceInformation?: { __typename?: 'CompanyHealthInsuranceInfo', isCoverageEligible?: boolean | null } | null, applications?: Array<{ __typename?: 'Application', uuid: string, step?: number | null }> | null } | null };

export type GetBusinessAttributesQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetBusinessAttributesQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', website: Array<string>, applications?: Array<{ __typename?: 'Application', uuid: string, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, companyInformation?: { __typename?: 'CompanyInfo', bizActivities?: { __typename?: 'BizActivities', hasVolunteerAccidentPolicy?: boolean | null, hasPriorCarriers?: boolean | null, priorCarriers?: string | null, hasHadWorkersCompPolicy?: boolean | null, hasPastDuePremiums?: boolean | null, beenCancelled?: boolean | null, policyCancelledReason?: string | null, beenDeclined?: boolean | null, sponsorSportsTeams?: boolean | null, hasTaxLeinBankrupcy?: boolean | null, offerHealthInsurance?: boolean | null, ownAircraftWatercraft?: boolean | null, use3rdPartyVendors?: boolean | null, thirdPartyDetails1?: string | null, thirdPartyDetails2?: string | null, thirdPartyDetails3?: string | null, thirdPartyDetails4?: string | null, hasVolunteers?: boolean | null, numberVolunteers?: number | null, volunteerActivities?: string | null, volunteerTravel?: boolean | null, hazardousMats?: boolean | null, hasWrittenSafteyProg?: boolean | null } | null } | null } | null };

export type UpdateBusinessAttributesMutationVariables = Exact<{
  uuid: Scalars['ID'];
  hasTaxLeinBankrupcy?: InputMaybe<Scalars['Boolean']>;
  hasWrittenSafteyProg?: InputMaybe<Scalars['Boolean']>;
  hazardousMats?: InputMaybe<Scalars['Boolean']>;
  offerHealthInsurance?: InputMaybe<Scalars['Boolean']>;
  ownAircraftWatercraft?: InputMaybe<Scalars['Boolean']>;
  sponsorSportsTeams?: InputMaybe<Scalars['Boolean']>;
  use3rdPartyVendors?: InputMaybe<Scalars['Boolean']>;
  hasVolunteers?: InputMaybe<Scalars['Boolean']>;
  numberVolunteers?: InputMaybe<Scalars['Int']>;
  volunteerActivities?: InputMaybe<Scalars['String']>;
  volunteerTravel?: InputMaybe<Scalars['Boolean']>;
  beenCancelled?: InputMaybe<Scalars['Boolean']>;
  beenDeclined?: InputMaybe<Scalars['Boolean']>;
  hasPastDuePremiums?: InputMaybe<Scalars['Boolean']>;
  hasHadWorkersCompPolicy?: InputMaybe<Scalars['Boolean']>;
  hasPriorCarriers?: InputMaybe<Scalars['Boolean']>;
  policyCancelledReason?: InputMaybe<Scalars['String']>;
  priorCarriers?: InputMaybe<Scalars['String']>;
  thirdPartyDetails1?: InputMaybe<Scalars['String']>;
  thirdPartyDetails2?: InputMaybe<Scalars['String']>;
  thirdPartyDetails3?: InputMaybe<Scalars['String']>;
  thirdPartyDetails4?: InputMaybe<Scalars['String']>;
  hasVolunteerAccidentPolicy?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateBusinessAttributesMutation = { __typename?: 'Mutation', updateProspectBizActivities?: { __typename?: 'UpdateProspectBizActivitiesPayload', uuid?: string | null } | null };

export type GetBusinessDetailsQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetBusinessDetailsQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', companyName: string, dba?: string | null, ein?: string | null, website: Array<string>, yearFounded?: number | null, workersCompApplication?: Array<{ __typename?: 'Application', step?: number | null, uuid: string, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, healthInsuranceApplication?: Array<{ __typename?: 'Application', step?: number | null, uuid: string }> | null, healthInsuranceUpsellApplication?: Array<{ __typename?: 'Application', step?: number | null, uuid: string }> | null, companyInformation?: { __typename?: 'CompanyInfo', yearsInBusiness?: number | null, hoursOfOperation?: string | null, industry?: string | null, industryOther?: string | null, industryNaics4?: string | null, industryNaics6?: string | null, ownerHalfStakeOther?: boolean | null, employeesWorkOtherStakes?: boolean | null, otherStakesDescription?: string | null, entityType?: string | null, isNonProfit?: boolean | null } | null, relatedEntities?: Array<{ __typename?: 'RelatedEntity', uuid: string, legalName: string, ein?: string | null, dba?: string | null, description?: string | null, isDependent: boolean, sharesLocation: boolean, hasW2Employees: boolean, hasOverlappingEmployees: boolean }> | null } | null };

export type UpdateBaseProspectMutationVariables = Exact<{
  uuid: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  dba?: InputMaybe<Scalars['String']>;
  ein?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  yearFounded?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateBaseProspectMutation = { __typename?: 'Mutation', updateBaseProspect?: { __typename?: 'UpdateBaseProspectPropertiesPayload', uuid?: string | null } | null };

export type UpdateProspectCompanyInfoMutationVariables = Exact<{
  uuid: Scalars['ID'];
  hoursOfOperation?: InputMaybe<Scalars['String']>;
  yearsInBusiness?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<Scalars['String']>;
  isNonProfit?: InputMaybe<Scalars['Boolean']>;
  ownerHalfStakeOther?: InputMaybe<Scalars['Boolean']>;
  employeesWorkOtherStakes?: InputMaybe<Scalars['Boolean']>;
  otherStakesDescription?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  industryOther?: InputMaybe<Scalars['String']>;
  industryNaics4?: InputMaybe<Scalars['String']>;
  industryNaics6?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProspectCompanyInfoMutation = { __typename?: 'Mutation', updateProspectCompanyInfo?: { __typename?: 'UpdateProspectCompanyInfoPayload', uuid?: string | null } | null };

export type UpdateRelatedEntitiesMutationVariables = Exact<{
  uuid: Scalars['ID'];
  relatedEntities: Array<RelatedEntityInput> | RelatedEntityInput;
}>;


export type UpdateRelatedEntitiesMutation = { __typename?: 'Mutation', updateRelatedEntities?: { __typename?: 'UpdateRelatedEntitiesPayload', relatedEntities?: Array<{ __typename?: 'RelatedEntity', uuid: string, legalName: string, ein?: string | null, dba?: string | null, hasW2Employees: boolean, hasOverlappingEmployees: boolean, isDependent: boolean }> | null } | null };

export type AddBussinessAddressMutationVariables = Exact<{
  uuid: Scalars['ID'];
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
  locationName?: InputMaybe<Scalars['String']>;
  isHq?: InputMaybe<Scalars['Boolean']>;
  subdivision?: InputMaybe<Scalars['String']>;
}>;


export type AddBussinessAddressMutation = { __typename?: 'Mutation', createOfficeLocation?: { __typename?: 'CreateOfficeLocationPayload', uuid?: string | null, autoValidated?: boolean | null, suggestedAddress?: { __typename?: 'SuggestedAddress', address1: string, address2?: string | null, city: string, state: string, zip: string } | null } | null };

export type DeleteBussinessAddressMutationVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type DeleteBussinessAddressMutation = { __typename?: 'Mutation', deleteOfficeLocation?: { __typename?: 'DeleteOfficeLocationPayload', uuid?: string | null } | null };

export type GetBusinessAddressQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetBusinessAddressQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', applications?: Array<{ __typename?: 'Application', uuid: string, createdAt: any }> | null, officeLocations?: Array<{ __typename?: 'OfficeLocation', address1: string, address2?: string | null, city: string, locationName?: string | null, state: string, zip: string, autoValidated?: boolean | null, uuid: string, isHq: boolean, subdivision?: string | null }> | null, employeeCensuses?: Array<{ __typename?: 'EmployeeCensus', officeLocationId?: string | null, isCompanyOwner?: boolean | null, isCompanyEmployee?: boolean | null, firstName: string }> | null } | null };

export type UpdateBussinessAddressMutationVariables = Exact<{
  uuid: Scalars['ID'];
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
  locationName?: InputMaybe<Scalars['String']>;
  isHq?: InputMaybe<Scalars['Boolean']>;
  subdivision?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBussinessAddressMutation = { __typename?: 'Mutation', updateOfficeLocation?: { __typename?: 'UpdateOfficeLocationPayload', uuid?: string | null, autoValidated?: boolean | null, suggestedAddress?: { __typename?: 'SuggestedAddress', address1: string, address2?: string | null, city: string, state: string, zip: string } | null } | null };

export type GetBusinessDescriptionQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetBusinessDescriptionQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', dba?: string | null, ein?: string | null, companyName: string, website: Array<string>, yearFounded?: number | null, applications?: Array<{ __typename?: 'Application', uuid: string, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, companyInformation?: { __typename?: 'CompanyInfo', businessDescription?: string | null, dailyOperationsOfEmployees?: string | null, hasUnionWorkers?: boolean | null } | null } | null };

export type UpdateBusinessDescriptionMutationVariables = Exact<{
  uuid: Scalars['ID'];
  businessDescription?: InputMaybe<Scalars['String']>;
  dailyOperationsOfEmployees?: InputMaybe<Scalars['String']>;
  hasUnionWorkers?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateBusinessDescriptionMutation = { __typename?: 'Mutation', updateProspectCompanyInfo?: { __typename?: 'UpdateProspectCompanyInfoPayload', uuid?: string | null } | null };

export type UpdateBusinessWebsiteMutationVariables = Exact<{
  uuid: Scalars['ID'];
  website?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  dba?: InputMaybe<Scalars['String']>;
  ein?: InputMaybe<Scalars['String']>;
  yearFounded?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateBusinessWebsiteMutation = { __typename?: 'Mutation', updateBaseProspect?: { __typename?: 'UpdateBaseProspectPropertiesPayload', uuid?: string | null } | null };

export type AddDocumentMutationVariables = Exact<{
  applicationId: Scalars['ID'];
  applicationField: Scalars['String'];
  fileSize?: InputMaybe<Scalars['Int']>;
  path: Scalars['String'];
}>;


export type AddDocumentMutation = { __typename?: 'Mutation', createDocument?: { __typename?: 'CreateDocumentPayload', uuid?: string | null } | null };

export type DeleteDocumentMutationVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: { __typename?: 'DeleteDocumentPayload', uuid?: string | null } | null };

export type GetDocumentQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', applications?: Array<{ __typename?: 'Application', uuid: string, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, companyInformation?: { __typename?: 'CompanyInfo', noLossRunsReportOtherReason?: string | null, noLossRunsReportReason?: string | null } | null } | null };

export type UpdateNoLossRunsReportReasonMutationVariables = Exact<{
  prospectUuid: Scalars['ID'];
  noLossRunsReportOtherReason?: InputMaybe<Scalars['String']>;
  noLossRunsReportReason?: InputMaybe<Scalars['String']>;
}>;


export type UpdateNoLossRunsReportReasonMutation = { __typename?: 'Mutation', updateNoLossRunsReportReason?: { __typename?: 'UpdateNoLossRunsReportReasonPayload', success: boolean } | null };

export type GetEpliQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetEpliQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', applications?: Array<{ __typename?: 'Application', uuid: string, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, companyInformation?: { __typename?: 'CompanyInfo', epli?: { __typename?: 'Epli', hasPolicy?: boolean | null, overTwentyFiveEe?: boolean | null, receivedEpliAllegations?: boolean | null, beenSuedFormerEmp?: boolean | null, offeredSeverancePackages?: boolean | null, claimDetails?: string | null, noEpliLossRunsReportOtherReason?: string | null, noEpliLossRunsReportReason?: string | null } | null } | null } | null };

export type UpdateEpliMutationVariables = Exact<{
  uuid: Scalars['ID'];
  hasPolicy?: InputMaybe<Scalars['Boolean']>;
  overTwentyFiveEe?: InputMaybe<Scalars['Boolean']>;
  receivedEpliAllegations?: InputMaybe<Scalars['Boolean']>;
  beenSuedFormerEmp?: InputMaybe<Scalars['Boolean']>;
  offeredSeverancePackages?: InputMaybe<Scalars['Boolean']>;
  claimDetails?: InputMaybe<Scalars['String']>;
  noEpliLossRunsReportOtherReason?: InputMaybe<Scalars['String']>;
  noEpliLossRunsReportReason?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEpliMutation = { __typename?: 'Mutation', updateProspectEpli?: { __typename?: 'UpdateProspectEpliPayload', uuid?: string | null } | null };

export type GetEmployeeAttributesQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetEmployeeAttributesQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', employeeCensuses?: Array<{ __typename?: 'EmployeeCensus', uuid: string, isCompanyOwner?: boolean | null, isCompanyEmployee?: boolean | null, firstName: string, middleName?: string | null, lastName: string, email: string }> | null, companyInformation?: { __typename?: 'CompanyInfo', bizActivities?: { __typename?: 'BizActivities', deliveries?: boolean | null, employeesWhoMakeDeliveries?: Array<{ __typename?: 'EmployeesWhoMakeDeliveries', employeeId?: string | null, deliveryTransportationType?: string | null, deliveryDistance?: string | null, deliveryFrequency?: string | null }> | null } | null, hasEmployees?: { __typename?: 'HasEmployees', travel?: boolean | null, hardware?: boolean | null, employeesPhysicalLabor?: boolean | null, hasContractors?: boolean | null, employmentDuration?: string | null, numberContractors?: string | null, percentContractors?: string | null, contractorWorkType?: string | null, contractorsHaveWorkComp?: boolean | null, contractorsHaveWorkersCompCois?: boolean | null, numberTemp?: string | null, boatsBridges?: boolean | null, employeesWorkUnderground?: boolean | null, employeesWorkOnLadders?: boolean | null, employeePerformHeavyLifting?: boolean | null, physicalDisability?: boolean | null, underageOrSenior?: boolean | null, employeesWhoUseBoatsBridges?: Array<string> | null, employeesWhoHavePhysicalDisabilities?: Array<string> | null, employeesWhoTravel?: Array<{ __typename?: 'EmployeesWhoTravel', employeeId?: string | null, travelPurpose: string, travelInternationally?: boolean | null, travelLocation: string, travelFrequency: string }> | null, employeesWhoUseTools?: Array<{ __typename?: 'EmployeesWhoUseTools', employeeId?: string | null, hardwareNames: string }> | null, underageOrSeniorEmployees?: Array<{ __typename?: 'UnderageOrSeniorEmployees', dateOfBirth: any, employeeId?: string | null, jobTitle: string }> | null, employeesWhoRequirePhysicalLabor?: Array<{ __typename?: 'EmployeesWhoRequirePhysicalLabor', employeeId?: string | null, percentPhysicalLabor?: string | null }> | null, employeesWhoWorkUnderground?: Array<{ __typename?: 'EmployeesWhoWorkUnderground', employeeId?: string | null, undergroundDescription?: string | null }> | null, employeesWhoWorkOnLadders?: Array<{ __typename?: 'EmployeesWhoWorkOnLadders', employeeId?: string | null, laddersDescription?: string | null }> | null, employeesWhoPerformHeavyLifting?: Array<{ __typename?: 'EmployeesWhoPerformHeavyLifting', employeeId?: string | null, maximumWeightLifted?: string | null }> | null } | null } | null } | null };

export type UpdateEmployeeAttributesMutationVariables = Exact<{
  uuid: Scalars['ID'];
  employeesWhoTravel?: InputMaybe<Array<EmployeesWhoTravelInput> | EmployeesWhoTravelInput>;
  employeesWhoUseTools?: InputMaybe<Array<EmployeesWhoUseToolsInput> | EmployeesWhoUseToolsInput>;
  underageOrSeniorEmployees?: InputMaybe<Array<UnderageOrSeniorEmployeesInput> | UnderageOrSeniorEmployeesInput>;
  travel?: InputMaybe<Scalars['Boolean']>;
  hardware?: InputMaybe<Scalars['Boolean']>;
  employeesPhysicalLabor?: InputMaybe<Scalars['Boolean']>;
  hasContractors?: InputMaybe<Scalars['Boolean']>;
  employmentDuration?: InputMaybe<Scalars['String']>;
  numberContractors?: InputMaybe<Scalars['String']>;
  percentContractors?: InputMaybe<Scalars['String']>;
  contractorWorkType?: InputMaybe<Scalars['String']>;
  contractorsHaveWorkComp?: InputMaybe<Scalars['Boolean']>;
  contractorsHaveWorkersCompCOIS?: InputMaybe<Scalars['Boolean']>;
  numberTemp?: InputMaybe<Scalars['String']>;
  boatsBridges?: InputMaybe<Scalars['Boolean']>;
  employeesWorkUnderground?: InputMaybe<Scalars['Boolean']>;
  employeesWorkOnLadders?: InputMaybe<Scalars['Boolean']>;
  employeePerformHeavyLifting?: InputMaybe<Scalars['Boolean']>;
  physicalDisability?: InputMaybe<Scalars['Boolean']>;
  underageOrSenior?: InputMaybe<Scalars['Boolean']>;
  employeesWhoRequirePhysicalLabor?: InputMaybe<Array<EmployeesWhoRequirePhysicalLaborInput> | EmployeesWhoRequirePhysicalLaborInput>;
  employeesWhoUseBoatsBridges?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  employeesWhoWorkUnderground?: InputMaybe<Array<EmployeesWhoWorkUndergroundInput> | EmployeesWhoWorkUndergroundInput>;
  employeesWhoWorkOnLadders?: InputMaybe<Array<EmployeesWhoWorkOnLaddersInput> | EmployeesWhoWorkOnLaddersInput>;
  employeesWhoPerformHeavyLifting?: InputMaybe<Array<EmployeesWhoPerformHeavyLiftingInput> | EmployeesWhoPerformHeavyLiftingInput>;
  employeesWhoHavePhysicalDisabilities?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateEmployeeAttributesMutation = { __typename?: 'Mutation', updateProspectEmployeeFlags?: { __typename?: 'UpdateProspectEmployeeFlagsPayload', uuid?: string | null } | null };

export type UpdateEmployeeDeliveryAttributeMutationVariables = Exact<{
  uuid: Scalars['ID'];
  deliveries?: InputMaybe<Scalars['Boolean']>;
  employeesWhoMakeDeliveries?: InputMaybe<Array<EmployeesWhoMakeDeliveriesInput> | EmployeesWhoMakeDeliveriesInput>;
}>;


export type UpdateEmployeeDeliveryAttributeMutation = { __typename?: 'Mutation', updateProspectBizActivities?: { __typename?: 'UpdateProspectBizActivitiesPayload', uuid?: string | null } | null };

export type AddOwnerAndEmployeeCensusMutationVariables = Exact<{
  prospectId: Scalars['ID'];
  firstName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  roleDescription?: InputMaybe<Scalars['String']>;
  ownerStake?: InputMaybe<Scalars['Int']>;
  isPaid?: InputMaybe<Scalars['String']>;
  salary?: InputMaybe<Scalars['Float']>;
  isCompanyOwner?: InputMaybe<Scalars['Boolean']>;
  isCompanyEmployee?: InputMaybe<Scalars['Boolean']>;
  salaryType?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hoursWeekly?: InputMaybe<Scalars['Float']>;
  email: Scalars['String'];
  officeLocationId?: InputMaybe<Scalars['ID']>;
  exemptionStatus?: InputMaybe<EmployeeExemptionStatusEnum>;
  isRemote: Scalars['Boolean'];
  remoteAddress?: InputMaybe<AddressInput>;
  employeeType?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  workersCompensationClassification?: InputMaybe<Scalars['String']>;
  adminAccess?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<EmployeeCensusSourceEnum>;
}>;


export type AddOwnerAndEmployeeCensusMutation = { __typename?: 'Mutation', createEmployeeCensus?: { __typename?: 'CreateEmployeeCensusPayload', uuid?: string | null, addressAutoValidated?: boolean | null, suggestedAddress?: { __typename?: 'SuggestedAddress', address1: string, address2?: string | null, city: string, state: string, zip: string } | null } | null };

export type DeleteOwnerAndEmployeeCensusMutationVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type DeleteOwnerAndEmployeeCensusMutation = { __typename?: 'Mutation', deleteEmployeeCensus?: { __typename?: 'DeleteEmployeeCensusPayload', uuid?: string | null } | null };

export type GetEmployeesQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetEmployeesQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', companyInformation?: { __typename?: 'CompanyInfo', hasEmployees?: { __typename?: 'HasEmployees', employeesWhoTravel?: Array<{ __typename?: 'EmployeesWhoTravel', employeeId?: string | null }> | null, employeesWhoUseTools?: Array<{ __typename?: 'EmployeesWhoUseTools', employeeId?: string | null }> | null, underageOrSeniorEmployees?: Array<{ __typename?: 'UnderageOrSeniorEmployees', employeeId?: string | null }> | null } | null } | null, employeeCensuses?: Array<{ __typename?: 'EmployeeCensus', uuid: string, officeLocationId?: string | null, email: string, firstName: string, middleName?: string | null, lastName: string, isCompanyOwner?: boolean | null, isCompanyEmployee?: boolean | null, employeeType?: string | null, employeeInformation?: { __typename?: 'EmployeeInformation', title?: string | null, department?: string | null, adminAccess?: boolean | null, salaryType?: string | null, salary?: number | null, hourlyRate?: number | null, hoursWeekly?: number | null, workersCompensationClassification?: string | null, exemptionStatus?: EmployeeExemptionStatusEnum | null, isRemote?: boolean | null, remoteAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, state: string, zip: string, autoValidated?: boolean | null } | null } | null }> | null, officeLocations?: Array<{ __typename?: 'OfficeLocation', locationName?: string | null, address2?: string | null, address1: string, city: string, state: string, zip: string, uuid: string, isHq: boolean }> | null } | null };

export type GetOwnerQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetOwnerQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', employeeCensuses?: Array<{ __typename?: 'EmployeeCensus', uuid: string, email: string, firstName: string, middleName?: string | null, lastName: string, isCompanyOwner?: boolean | null, isCompanyEmployee?: boolean | null, officeLocationId?: string | null, employeeInformation?: { __typename?: 'EmployeeInformation', isPaid?: string | null, title?: string | null, roleDescription?: string | null, salaryType?: string | null, salary?: number | null, hourlyRate?: number | null, hoursWeekly?: number | null, ownerStake?: number | null, exemptionStatus?: EmployeeExemptionStatusEnum | null, isRemote?: boolean | null, remoteAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, state: string, zip: string, autoValidated?: boolean | null } | null } | null }> | null, officeLocations?: Array<{ __typename?: 'OfficeLocation', locationName?: string | null, address1: string, address2?: string | null, city: string, state: string, zip: string, uuid: string, isHq: boolean }> | null } | null };

export type UpdateOwnerAndEmployeeCensusMutationVariables = Exact<{
  uuid: Scalars['ID'];
  firstName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  roleDescription?: InputMaybe<Scalars['String']>;
  ownerStake?: InputMaybe<Scalars['Int']>;
  isPaid?: InputMaybe<Scalars['String']>;
  salary?: InputMaybe<Scalars['Float']>;
  isCompanyOwner?: InputMaybe<Scalars['Boolean']>;
  isCompanyEmployee?: InputMaybe<Scalars['Boolean']>;
  salaryType?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hoursWeekly?: InputMaybe<Scalars['Float']>;
  email: Scalars['String'];
  officeLocationId?: InputMaybe<Scalars['ID']>;
  exemptionStatus?: InputMaybe<EmployeeExemptionStatusEnum>;
  isRemote: Scalars['Boolean'];
  remoteAddress?: InputMaybe<AddressInput>;
  employeeType?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  workersCompensationClassification?: InputMaybe<Scalars['String']>;
  adminAccess?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateOwnerAndEmployeeCensusMutation = { __typename?: 'Mutation', updateEmployeeCensus?: { __typename?: 'UpdateEmployeeCensusPayload', uuid?: string | null, addressAutoValidated?: boolean | null, suggestedAddress?: { __typename?: 'SuggestedAddress', address1: string, address2?: string | null, city: string, state: string, zip: string } | null } | null };

export type GetOwnerAndEmployeeCensusQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetOwnerAndEmployeeCensusQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', employeeCensuses?: Array<{ __typename?: 'EmployeeCensus', uuid: string, officeLocationId?: string | null, email: string, firstName: string, middleName?: string | null, lastName: string, isCompanyOwner?: boolean | null, isCompanyEmployee?: boolean | null, employeeType?: string | null, employeeInformation?: { __typename?: 'EmployeeInformation', isPaid?: string | null, title?: string | null, roleDescription?: string | null, department?: string | null, adminAccess?: boolean | null, salaryType?: string | null, salary?: number | null, hourlyRate?: number | null, hoursWeekly?: number | null, workersCompensationClassification?: string | null, ownerStake?: number | null, exemptionStatus?: EmployeeExemptionStatusEnum | null, isRemote?: boolean | null, remoteAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, state: string, zip: string, autoValidated?: boolean | null } | null } | null }> | null, officeLocations?: Array<{ __typename?: 'OfficeLocation', locationName?: string | null, address2?: string | null, address1: string, city: string, state: string, zip: string, uuid: string, isHq: boolean }> | null, workersCompApplication?: Array<{ __typename?: 'Application', uuid: string, status?: ApplicationStatusEnum | null }> | null, healthInsuranceApplication?: Array<{ __typename?: 'Application', uuid: string, status?: ApplicationStatusEnum | null }> | null } | null };

export type GetProspectDataQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetProspectDataQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', website: Array<string>, uuid: string, ein?: string | null, companyName: string, dba?: string | null, yearFounded?: number | null, applications?: Array<{ __typename?: 'Application', uuid: string, createdAt: any, documents?: Array<{ __typename?: 'Document', accessLink: string, applicationField: string, fileName: string, uuid: string }> | null }> | null, relatedEntities?: Array<{ __typename?: 'RelatedEntity', uuid: string, legalName: string, ein?: string | null, dba?: string | null, description?: string | null, isDependent: boolean, sharesLocation: boolean, hasW2Employees: boolean, hasOverlappingEmployees: boolean }> | null, companyInformation?: { __typename?: 'CompanyInfo', industry?: string | null, industryOther?: string | null, industryNaics4?: string | null, industryNaics6?: string | null, noLossRunsReportOtherReason?: string | null, noLossRunsReportReason?: string | null, employeesWorkOtherStakes?: boolean | null, otherStakesDescription?: string | null, ownerHalfStakeOther?: boolean | null, dailyOperationsOfEmployees?: string | null, entityName?: string | null, npoStatus?: string | null, entityType?: string | null, isNonProfit?: boolean | null, yearsInBusiness?: number | null, isRemainingStateInvestors?: boolean | null, hasExistingPolicy?: boolean | null, hasUnionWorkers?: boolean | null, hoursOfOperation?: string | null, primaryPhoneNumber?: string | null, businessDescription?: string | null, epli?: { __typename?: 'Epli', beenSuedFormerEmp?: boolean | null, claimDetails?: string | null, hasPolicy?: boolean | null, noEpliLossRunsReportReason?: string | null, noEpliLossRunsReportOtherReason?: string | null, offeredSeverancePackages?: boolean | null, overTwentyFiveEe?: boolean | null, receivedEpliAllegations?: boolean | null } | null, bizActivities?: { __typename?: 'BizActivities', beenCancelled?: boolean | null, beenDeclined?: boolean | null, deliveries?: boolean | null, hasPastDuePremiums?: boolean | null, hasPriorCarriers?: boolean | null, hasHadWorkersCompPolicy?: boolean | null, hasTaxLeinBankrupcy?: boolean | null, hasVolunteers?: boolean | null, hasVolunteerAccidentPolicy?: boolean | null, hasWrittenSafteyProg?: boolean | null, hazardousMats?: boolean | null, numberVolunteers?: number | null, offerHealthInsurance?: boolean | null, ownAircraftWatercraft?: boolean | null, policyCancelledReason?: string | null, priorCarriers?: string | null, requirePhysicals?: boolean | null, sponsorSportsTeams?: boolean | null, thirdPartyDetails1?: string | null, thirdPartyDetails2?: string | null, thirdPartyDetails3?: string | null, thirdPartyDetails4?: string | null, thirdPartyDetails5?: string | null, use3rdPartyVendors?: boolean | null, volunteerActivities?: string | null, volunteerAges?: string | null, volunteerTravel?: boolean | null, workersCompDeclinedReason?: string | null, employeesWhoMakeDeliveries?: Array<{ __typename?: 'EmployeesWhoMakeDeliveries', employeeId?: string | null, deliveryDistance?: string | null, deliveryFrequency?: string | null, deliveryTransportationType?: string | null }> | null } | null, hasEmployees?: { __typename?: 'HasEmployees', travel?: boolean | null, employeesWhoUseBoatsBridges?: Array<string> | null, employeesWhoHavePhysicalDisabilities?: Array<string> | null, hardware?: boolean | null, employeesPhysicalLabor?: boolean | null, hasContractors?: boolean | null, employmentDuration?: string | null, numberContractors?: string | null, percentContractors?: string | null, contractorWorkType?: string | null, contractorsHaveWorkComp?: boolean | null, contractorsHaveWorkersCompCois?: boolean | null, numberTemp?: string | null, boatsBridges?: boolean | null, employeesWorkUnderground?: boolean | null, employeesWorkOnLadders?: boolean | null, employeePerformHeavyLifting?: boolean | null, physicalDisability?: boolean | null, underageOrSenior?: boolean | null, employeesWhoTravel?: Array<{ __typename?: 'EmployeesWhoTravel', employeeId?: string | null, travelPurpose: string, travelInternationally?: boolean | null, travelLocation: string, travelFrequency: string }> | null, employeesWhoUseTools?: Array<{ __typename?: 'EmployeesWhoUseTools', employeeId?: string | null, hardwareNames: string }> | null, underageOrSeniorEmployees?: Array<{ __typename?: 'UnderageOrSeniorEmployees', dateOfBirth: any, employeeId?: string | null, jobTitle: string }> | null, employeesWhoRequirePhysicalLabor?: Array<{ __typename?: 'EmployeesWhoRequirePhysicalLabor', employeeId?: string | null, percentPhysicalLabor?: string | null }> | null, employeesWhoWorkUnderground?: Array<{ __typename?: 'EmployeesWhoWorkUnderground', employeeId?: string | null, undergroundDescription?: string | null }> | null, employeesWhoWorkOnLadders?: Array<{ __typename?: 'EmployeesWhoWorkOnLadders', employeeId?: string | null, laddersDescription?: string | null }> | null, employeesWhoPerformHeavyLifting?: Array<{ __typename?: 'EmployeesWhoPerformHeavyLifting', employeeId?: string | null, maximumWeightLifted?: string | null }> | null } | null } | null, officeLocations?: Array<{ __typename?: 'OfficeLocation', address1: string, address2?: string | null, city: string, locationName?: string | null, zip: string, state: string, uuid: string, isHq: boolean, subdivision?: string | null, autoValidated?: boolean | null }> | null, employeeCensuses?: Array<{ __typename?: 'EmployeeCensus', employeeType?: string | null, email: string, firstName: string, isCompanyOwner?: boolean | null, isCompanyEmployee?: boolean | null, lastName: string, middleName?: string | null, uuid: string, officeLocationId?: string | null, employeeInformation?: { __typename?: 'EmployeeInformation', adminAccess?: boolean | null, department?: string | null, employeesWorkOtherStakes?: boolean | null, hourlyRate?: number | null, hoursWeekly?: number | null, isPaid?: string | null, manager?: string | null, ownerStake?: number | null, roleDescription?: string | null, salary?: number | null, salaryType?: string | null, title?: string | null, workersCompensationClassification?: string | null, exemptionStatus?: EmployeeExemptionStatusEnum | null, isRemote?: boolean | null, remoteAddress?: { __typename?: 'Address', address1: string, address2?: string | null, city: string, state: string, zip: string, autoValidated?: boolean | null } | null } | null }> | null } | null };

export type CreateApplicationMutationVariables = Exact<{
  prospectId: Scalars['ID'];
  prospectCanonicalId?: InputMaybe<Scalars['String']>;
  applicationSteps?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateApplicationMutation = { __typename?: 'Mutation', createApplication?: { __typename?: 'CreateApplicationPayload', uuid?: string | null } | null };

export type GetStepQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetStepQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', applications?: Array<{ __typename?: 'Application', step?: number | null, flowVersion?: string | null, uuid: string, status?: ApplicationStatusEnum | null, createdAt: any }> | null } | null };

export type UpdateStepMutationVariables = Exact<{
  uuid: Scalars['ID'];
  step: Scalars['Int'];
}>;


export type UpdateStepMutation = { __typename?: 'Mutation', updateApplicationStep?: { __typename?: 'UpdateApplicationStepPayload', uuid?: string | null } | null };

export type GetProspectQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetProspectQuery = { __typename?: 'Query', prospect?: { __typename?: 'Prospect', companyName: string, dba?: string | null, ein?: string | null, uuid: string } | null };

export type UpsertHealthInsEmployeeCensusMutationVariables = Exact<{
  employeeHealthCensus: DependentCensusInput;
  prospectId: Scalars['ID'];
  source: EmployeeCensusSourceEnum;
}>;


export type UpsertHealthInsEmployeeCensusMutation = { __typename?: 'Mutation', upsertHealthInsEmployeeCensus?: { __typename?: 'UpsertHealthInsEmployeeCensusPayload', uuids?: Array<string> | null } | null };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601Date: any;
  ISO8601DateTime: any;
};

/** Sensitive address information */
export type AddressInput = {
  /** Address of office location */
  address1: Scalars['String'];
  /** Optional additional address information */
  address2?: InputMaybe<Scalars['String']>;
  /** City that this office location resides */
  city: Scalars['String'];
  /** The state abbreviation where this office location resides */
  state: Scalars['String'];
  /** The zip code (with optional + 4 code) of this office location */
  zip: Scalars['String'];
};

/** Input object for filtering prospect applications */
export type ApplicationFilter = {
  /** Include applications in the response that have a status of CANCELLED or ARCHIVED */
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  /** The max number of applications to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** The type of sort order to use */
  sortBy?: InputMaybe<Scalars['String']>;
  /** The type of application(s) to load */
  type?: InputMaybe<ApplicationTypeEnum>;
  /** The uuid of the application if known */
  uuid?: InputMaybe<Scalars['ID']>;
};

/** Enum representing the various applications types that can be submitted */
export enum ApplicationStatusEnum {
  /** An application that was submitted and approved, but not quoted */
  Approved = 'APPROVED',
  /** An archived application */
  Archived = 'ARCHIVED',
  /** An application that was cancelled */
  Cancelled = 'CANCELLED',
  /** A submitted application */
  Completed = 'COMPLETED',
  /** An application that was submitted & valid, but denied */
  Denied = 'DENIED',
  /** An application in progress */
  InProgress = 'IN_PROGRESS',
  /** An application created but not past step 0 */
  NotStarted = 'NOT_STARTED',
  /** An application past the start page */
  Opened = 'OPENED',
  /** An application that was submitted, approved, and quoted */
  Quoted = 'QUOTED',
  /** An application that was submitted, but rejected due to an issue */
  Rejected = 'REJECTED'
}

/** Enum representing the various applications types that can be submitted */
export enum ApplicationTypeEnum {
  /** A core company application */
  CoreCompany = 'CORE_COMPANY',
  /** A health insurance application */
  HealthInsurance = 'HEALTH_INSURANCE',
  /** A health insurance application for an existing company */
  HealthInsuranceUpsell = 'HEALTH_INSURANCE_UPSELL',
  /** A workers compensation application */
  WorkersComp = 'WORKERS_COMP'
}

/** A set of flags related to a business' activities */
export type BizActivitiesInput = {
  beenCancelled?: InputMaybe<Scalars['Boolean']>;
  beenDeclined?: InputMaybe<Scalars['Boolean']>;
  deliveries?: InputMaybe<Scalars['Boolean']>;
  employeesWhoMakeDeliveries?: InputMaybe<Array<EmployeesWhoMakeDeliveriesInput>>;
  hasHadWorkersCompPolicy?: InputMaybe<Scalars['Boolean']>;
  hasPastDuePremiums?: InputMaybe<Scalars['Boolean']>;
  hasPriorCarriers?: InputMaybe<Scalars['Boolean']>;
  hasTaxLeinBankrupcy?: InputMaybe<Scalars['Boolean']>;
  hasVolunteerAccidentPolicy?: InputMaybe<Scalars['Boolean']>;
  hasVolunteers?: InputMaybe<Scalars['Boolean']>;
  hasWrittenSafteyProg?: InputMaybe<Scalars['Boolean']>;
  hazardousMats?: InputMaybe<Scalars['Boolean']>;
  numberVolunteers?: InputMaybe<Scalars['Int']>;
  offerHealthInsurance?: InputMaybe<Scalars['Boolean']>;
  ownAircraftWatercraft?: InputMaybe<Scalars['Boolean']>;
  policyCancelledReason?: InputMaybe<Scalars['String']>;
  priorCarriers?: InputMaybe<Scalars['String']>;
  requirePhysicals?: InputMaybe<Scalars['Boolean']>;
  sponsorSportsTeams?: InputMaybe<Scalars['Boolean']>;
  thirdPartyDetails1?: InputMaybe<Scalars['String']>;
  thirdPartyDetails2?: InputMaybe<Scalars['String']>;
  thirdPartyDetails3?: InputMaybe<Scalars['String']>;
  thirdPartyDetails4?: InputMaybe<Scalars['String']>;
  thirdPartyDetails5?: InputMaybe<Scalars['String']>;
  use3rdPartyVendors?: InputMaybe<Scalars['Boolean']>;
  volunteerActivities?: InputMaybe<Scalars['String']>;
  volunteerAges?: InputMaybe<Scalars['String']>;
  volunteerTravel?: InputMaybe<Scalars['Boolean']>;
  workersCompDeclinedReason?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CancelApplication */
export type CancelApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The UUID of the application to cancel */
  uuid: Scalars['ID'];
};

/** A cobra census */
export type CobraCensusInput = {
  /** UUID of the employee to associate with this dependent */
  cobraEmployeeId?: InputMaybe<Scalars['ID']>;
  /** Date of birth of the dependent census */
  dateOfBirth: Scalars['ISO8601Date'];
  /** First name of the dependent census */
  firstName: Scalars['String'];
  /** Gender of the dependent census */
  gender: GenderTypeEnum;
  /** The health insurance plan information to update in the Cobra Census record */
  healthInsInfo?: InputMaybe<HealthInsuranceInfoInput>;
  /** Last name of the dependent census */
  lastName: Scalars['String'];
  /** Type of the dependent census */
  participantType: ParticipantTypeEnum;
  /** The uuid of the dependent census record to update */
  uuid?: InputMaybe<Scalars['ID']>;
  /** The zip code (with optional + 4 code) of this dependent */
  zip?: InputMaybe<Scalars['String']>;
};

/** Allows for updating the Health Insurance Information related to a Prospect. */
export type CompanyHealthInsuranceInfoInput = {
  /** The number of employees eligible for benefits */
  benefitEligibleEmployees?: InputMaybe<Scalars['Int']>;
  /** If any former employees subscribe to COBRA benefits */
  cobraUsage?: InputMaybe<Scalars['Boolean']>;
  /** The number of users (employees & dependents) currently subscribed to COBRA */
  cobraUsers?: InputMaybe<Scalars['Int']>;
  /** If this company is a member of a controlled group */
  controlledGroup?: InputMaybe<Scalars['Boolean']>;
  /** If the company currently offers health insurance the carrier that is being used */
  currentCarrier?: InputMaybe<HealthcareCarrierTypeEnum>;
  /** If "other" is selected for the "current_carrier" use this field to name the carrier */
  currentCarrierOther?: InputMaybe<Scalars['String']>;
  /** If the company currently uses a PEO */
  currentPeo?: InputMaybe<Scalars['String']>;
  /** The name of the PEO subscribed to if not Justworks */
  currentPeoOther?: InputMaybe<Scalars['String']>;
  /** The next health insurance renewal date if the company currently offers health insurance benefits */
  currentRenewalDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** If the company currently offers health insurance benefits */
  currentlyOfferHealthInsurance?: InputMaybe<Scalars['Boolean']>;
  /** If this company currently uses a PEO */
  isOnPeo?: InputMaybe<Scalars['Boolean']>;
  /** The date that the company wants to start offering Health Insurance benefits */
  startingCoverageDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The nested json data for a prospect's company */
export type CompanyInfoInput = {
  /** Has the company been sued by a former employee? */
  beenSuedFormerEmp?: InputMaybe<Scalars['Boolean']>;
  /** Description of the business */
  businessDescription?: InputMaybe<Scalars['String']>;
  businessOverlap?: InputMaybe<Scalars['Boolean']>;
  dailyOperationsOfEmployees?: InputMaybe<Scalars['String']>;
  employeesWorkOtherStakes?: InputMaybe<Scalars['Boolean']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  hasExistingPolicy?: InputMaybe<Scalars['Boolean']>;
  /** Does the company employ unionized workers? */
  hasUnionWorkers?: InputMaybe<Scalars['Boolean']>;
  /** Hours of operation of the business */
  hoursOfOperation?: InputMaybe<Scalars['String']>;
  /** Company industry classification (2 digit) */
  industry?: InputMaybe<Scalars['String']>;
  /** Company industry classification (4 digit) */
  industryNaics4?: InputMaybe<Scalars['String']>;
  /** Company industry classification (6 digit) */
  industryNaics6?: InputMaybe<Scalars['String']>;
  /** Non-existing industry classification */
  industryOther?: InputMaybe<Scalars['String']>;
  /** Is this business a non-profit entity? */
  isNonProfit?: InputMaybe<Scalars['Boolean']>;
  isRemainingStateInvestors?: InputMaybe<Scalars['Boolean']>;
  npoStatus?: InputMaybe<Scalars['String']>;
  otherStakesDescription?: InputMaybe<Scalars['String']>;
  ownerHalfStakeOther?: InputMaybe<Scalars['Boolean']>;
  /** Primary phone number of the business */
  primaryPhoneNumber?: InputMaybe<Scalars['String']>;
  /** The number of years the company has been in business */
  yearsInBusiness?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CoverageEligibility */
export type CoverageEligibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Uuid of prospect we check eligiblity of */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of CreateApplication */
export type CreateApplicationInput = {
  /** The type of application to create */
  appType: ApplicationTypeEnum;
  /** The names of the application steps required for completion */
  applicationSteps?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Corresponding Clockwork Company Uuid, used to prefill data for mdv upsell prospects */
  clockworkCompanyId?: InputMaybe<Scalars['ID']>;
  /** The uuid of the clockwork member this application should be linked to */
  createdBy?: InputMaybe<Scalars['ID']>;
  /** The canonical id of the prospect this application should be linked to */
  prospectCanonicalId?: InputMaybe<Scalars['String']>;
  /** The uuid of the prospect this application should be linked */
  prospectId: Scalars['ID'];
};

/** Autogenerated input type of CreateDependentCensuses */
export type CreateDependentCensusesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Dependent censuses to be created */
  dependentCensuses: Array<DependentCensusInput>;
  /** UUID of the the prospect */
  prospectId: Scalars['ID'];
};

/** Autogenerated input type of CreateDocument */
export type CreateDocumentInput = {
  /** The field of the application where this document is included */
  applicationField: Scalars['String'];
  /** UUID of the application to associate this document */
  applicationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The size of the file stored. If this is not included it will be loaded from S3 */
  fileSize?: InputMaybe<Scalars['Int']>;
  /** The mime_type of the file stored. If this is not included it will be loaded from S3 */
  mimeType?: InputMaybe<Scalars['String']>;
  /** The original filename. If this is not included it will be loaded from S3 */
  originalFileName?: InputMaybe<Scalars['String']>;
  /** The location of the uploaded file within S3 */
  path: Scalars['String'];
};

/** Autogenerated input type of CreateEmployeeCensus */
export type CreateEmployeeCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Date of birth of the employee */
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']>;
  /** Email of the employee */
  email: Scalars['String'];
  /** Additional information about the employee and their work */
  employeeInformation?: InputMaybe<EmployeeInformationInput>;
  /** The type of employee */
  employeeType?: InputMaybe<Scalars['String']>;
  /** First name of the employee */
  firstName: Scalars['String'];
  /** Gender at birth of the employee */
  gender?: InputMaybe<GenderTypeEnum>;
  /** Is this employee an employee of the company? */
  isCompanyEmployee?: InputMaybe<Scalars['Boolean']>;
  /** Is this employee also an owner of the company? */
  isCompanyOwner?: InputMaybe<Scalars['Boolean']>;
  /** Last name of the employee */
  lastName: Scalars['String'];
  /** Optional middle name of the employee */
  middleName?: InputMaybe<Scalars['String']>;
  /** UUID of the office location to associate with this employee */
  officeLocationId?: InputMaybe<Scalars['ID']>;
  /** Optional preferred name of the employee */
  preferredName?: InputMaybe<Scalars['String']>;
  /** Primary phone number of the employee */
  primaryPhone?: InputMaybe<Scalars['String']>;
  /** UUID of the prospective company that this employee is a member */
  prospectId: Scalars['ID'];
  /** The source of the employee census record */
  source?: InputMaybe<EmployeeCensusSourceEnum>;
  /** SSN of the employee */
  ssn?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateOfficeLocation */
export type CreateOfficeLocationInput = {
  /** Address of office location */
  address1: Scalars['String'];
  /** Optional additional address information */
  address2?: InputMaybe<Scalars['String']>;
  /** City that this office location resides */
  city: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Specifies if this location is the primary headquarters of the organization */
  isHq?: InputMaybe<Scalars['Boolean']>;
  /** Unique value specifying a custom name for this office location */
  locationName?: InputMaybe<Scalars['String']>;
  /** The uuid of the prospect this application should be linked */
  prospectId: Scalars['ID'];
  /** The state abbreviation where this office location resides */
  state: Scalars['String'];
  /** The subdivision of an address (in the US, this will be a County). */
  subdivision?: InputMaybe<Scalars['String']>;
  /** An indicator for whether the subdivsion was validated */
  subdivisionValidated?: InputMaybe<Scalars['Boolean']>;
  /** The type of office location this record represents */
  type?: InputMaybe<Scalars['String']>;
  /** The zip code (with optional + 4 code) of this office location */
  zip: Scalars['String'];
};

/** Autogenerated input type of DeleteApplication */
export type DeleteApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The uuid of the application to be deleted */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of DeleteCobraCensus */
export type DeleteCobraCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The uuid of the cobra census record to delete */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of DeleteDependentCensus */
export type DeleteDependentCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Type of the dependent census */
  participantType: ParticipantTypeEnum;
  /** The uuid of the dependent census record to delete */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of DeleteDependentCensuses */
export type DeleteDependentCensusesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID of the the prospect */
  prospectId: Scalars['ID'];
  /** The uuid of the dependent census record to delete */
  uuids: Array<Scalars['ID']>;
};

/** Autogenerated input type of DeleteDocument */
export type DeleteDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID of the document to delete */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of DeleteEmployeeCensus */
export type DeleteEmployeeCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The uuid of the employee to delete */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of DeleteOfficeLocation */
export type DeleteOfficeLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The uuid of the office location to delete */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of DeleteProspect */
export type DeleteProspectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The uuid of the prospective company to delete */
  uuid: Scalars['ID'];
};

/** A dependent census */
export type DependentCensusInput = {
  /** Date of birth of the dependent census */
  dateOfBirth: Scalars['ISO8601Date'];
  /** UUID of the employee to associate with this dependent */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** First name of the dependent census */
  firstName: Scalars['String'];
  /** Gender of the dependent census */
  gender: GenderTypeEnum;
  /** The health insurance plan information to update in the employee census record */
  healthInsInfo?: InputMaybe<HealthInsuranceInfoInput>;
  /** Is this employee also an owner of the company? */
  isCompanyOwner?: InputMaybe<Scalars['Boolean']>;
  /** Is this employee waiving the option for health insurance? */
  isWaiving?: InputMaybe<Scalars['Boolean']>;
  /** Last name of the dependent census */
  lastName: Scalars['String'];
  /** Type of the dependent census */
  participantType: ParticipantTypeEnum;
  /** The state abbreviation where this person resides */
  state?: InputMaybe<Scalars['String']>;
  /** The uuid of the dependent census record to update */
  uuid?: InputMaybe<Scalars['ID']>;
  /** The zip code (with optional + 4 code) of this dependent */
  zip: Scalars['String'];
};

/** Enum representing the various sources of employee census data */
export enum EmployeeCensusSourceEnum {
  /** Employee census data from a Clockwork member event */
  ClockworkMemberEvent = 'CLOCKWORK_MEMBER_EVENT',
  /** Employee census data from a health insurance application for an existing company */
  HiUpsell = 'HI_UPSELL',
  /** Employee census data from a health insurance application */
  WwHiApp = 'WW_HI_APP',
  /** Employee census data from a workers compensation application */
  WwWcApp = 'WW_WC_APP'
}

/** Enum representing the statuses that can be submitted */
export enum EmployeeExemptionStatusEnum {
  Exempt = 'EXEMPT',
  NonExempt = 'NON_EXEMPT'
}

/** A set of flags indicating whether a business has employees of various types */
export type EmployeeFlagsInput = {
  boatsBridges?: InputMaybe<Scalars['Boolean']>;
  contractorWorkLocation?: InputMaybe<Scalars['String']>;
  contractorWorkType?: InputMaybe<Scalars['String']>;
  contractorsHaveWorkComp?: InputMaybe<Scalars['Boolean']>;
  contractorsHaveWorkersCompCOIS?: InputMaybe<Scalars['Boolean']>;
  deliveries?: InputMaybe<Scalars['Boolean']>;
  employeePerformHeavyLifting?: InputMaybe<Scalars['Boolean']>;
  employeesPhysicalLabor?: InputMaybe<Scalars['Boolean']>;
  employeesWhoAreIndependentContractors?: InputMaybe<Array<EmployeesWhoAreIndependentContractorsInput>>;
  employeesWhoHavePhysicalDisabilities?: InputMaybe<Array<Scalars['ID']>>;
  employeesWhoPerformHeavyLifting?: InputMaybe<Array<EmployeesWhoPerformHeavyLiftingInput>>;
  employeesWhoRequirePhysicalLabor?: InputMaybe<Array<EmployeesWhoRequirePhysicalLaborInput>>;
  employeesWhoTravel?: InputMaybe<Array<EmployeesWhoTravelInput>>;
  employeesWhoUseBoatsBridges?: InputMaybe<Array<Scalars['ID']>>;
  employeesWhoUseTools?: InputMaybe<Array<EmployeesWhoUseToolsInput>>;
  employeesWhoWorkOnLadders?: InputMaybe<Array<EmployeesWhoWorkOnLaddersInput>>;
  employeesWhoWorkUnderground?: InputMaybe<Array<EmployeesWhoWorkUndergroundInput>>;
  employeesWorkOnLadders?: InputMaybe<Scalars['Boolean']>;
  employeesWorkUnderground?: InputMaybe<Scalars['Boolean']>;
  employmentDuration?: InputMaybe<Scalars['String']>;
  exactAges?: InputMaybe<Scalars['String']>;
  hardware?: InputMaybe<Scalars['Boolean']>;
  hardwareHandling?: InputMaybe<Scalars['Boolean']>;
  hardwareHandlingNames?: InputMaybe<Scalars['String']>;
  hasContractors?: InputMaybe<Scalars['Boolean']>;
  internationalTravelCity?: InputMaybe<Scalars['String']>;
  internationalTravelCountry?: InputMaybe<Scalars['String']>;
  internationalTravelFrequency?: InputMaybe<Scalars['String']>;
  internationalTravelName?: InputMaybe<Scalars['String']>;
  nameUnderageSenior?: InputMaybe<Scalars['String']>;
  numberContractors?: InputMaybe<Scalars['String']>;
  numberTemp?: InputMaybe<Scalars['String']>;
  numberUnderageOrSenior?: InputMaybe<Scalars['String']>;
  percentContractors?: InputMaybe<Scalars['String']>;
  physicalDisability?: InputMaybe<Scalars['Boolean']>;
  seasonalTemp?: InputMaybe<Scalars['Boolean']>;
  stateTravelFrequency?: InputMaybe<Scalars['String']>;
  stateTravelName?: InputMaybe<Scalars['String']>;
  tempEmployeeDuration?: InputMaybe<Scalars['String']>;
  tempEmployeeWork?: InputMaybe<Scalars['String']>;
  travel?: InputMaybe<Scalars['Boolean']>;
  travelInternational?: InputMaybe<Scalars['Boolean']>;
  travelLocations?: InputMaybe<Scalars['Boolean']>;
  travelNames?: InputMaybe<Scalars['String']>;
  underageOrSenior?: InputMaybe<Scalars['Boolean']>;
  underageOrSeniorEmployees?: InputMaybe<Array<UnderageOrSeniorEmployeesInput>>;
  underageOrSeniorWork?: InputMaybe<Scalars['String']>;
  undergroundLadders?: InputMaybe<Scalars['Boolean']>;
  worksWithChildren?: InputMaybe<Scalars['Boolean']>;
};

/** Sensitive employee information */
export type EmployeeInformationInput = {
  /** Should this employee be given admin access? */
  adminAccess?: InputMaybe<Scalars['Boolean']>;
  /** The department of this employee */
  department?: InputMaybe<Scalars['String']>;
  /** Exemption status of the employee */
  exemptionStatus?: InputMaybe<EmployeeExemptionStatusEnum>;
  /** Hourly rate of this employee if applicable */
  hourlyRate?: InputMaybe<Scalars['Float']>;
  /** Number of hours expected to be worked weekly */
  hoursWeekly?: InputMaybe<Scalars['Float']>;
  /** Invitation message to send this employee for enrollment */
  inviteMessage?: InputMaybe<Scalars['String']>;
  /** Is this a paid employee (if they are an owner) */
  isPaid?: InputMaybe<Scalars['String']>;
  /** Does this employee work remotely? */
  isRemote?: InputMaybe<Scalars['Boolean']>;
  /** The manager of this employee */
  manager?: InputMaybe<Scalars['String']>;
  /** What is this employee's stake in the company if they are an owner */
  ownerStake?: InputMaybe<Scalars['Int']>;
  /** The address of where the remote employee works (if applicable) */
  remoteAddress?: InputMaybe<AddressInput>;
  /** Description of this employee's role */
  roleDescription?: InputMaybe<Scalars['String']>;
  /** Salary of this employee */
  salary?: InputMaybe<Scalars['Float']>;
  /** The type of salary this employee receives */
  salaryType?: InputMaybe<Scalars['String']>;
  /** The start date of this employee */
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** Title of this employee */
  title?: InputMaybe<Scalars['String']>;
  /** Workers Compensation classification */
  workersCompensationClassification?: InputMaybe<Scalars['String']>;
};

/** A list of employees who are independent contractors */
export type EmployeesWhoAreIndependentContractorsInput = {
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
};

/** A list of employees who make deliveries */
export type EmployeesWhoMakeDeliveriesInput = {
  /** The distance an employee travels */
  deliveryDistance?: InputMaybe<Scalars['String']>;
  /** How frequently an employee makes deliveries */
  deliveryFrequency?: InputMaybe<Scalars['String']>;
  /** The type of transportation an employee uses */
  deliveryTransportationType?: InputMaybe<Scalars['String']>;
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
};

/** A list of employees who perform heavy lifting */
export type EmployeesWhoPerformHeavyLiftingInput = {
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** The maximum amount of weight an employee lifts */
  maximumWeightLifted?: InputMaybe<Scalars['String']>;
};

/** A list of employees who require physical labor */
export type EmployeesWhoRequirePhysicalLaborInput = {
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** The quartile of the day the employee performs physical labor */
  percentPhysicalLabor?: InputMaybe<Scalars['String']>;
};

/** A list of employees who travel */
export type EmployeesWhoTravelInput = {
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** The first name of the employee */
  firstName?: InputMaybe<Scalars['String']>;
  /** The last name of the employee */
  lastName?: InputMaybe<Scalars['String']>;
  /** The middle of the employee */
  middleName?: InputMaybe<Scalars['String']>;
  /** The travel frequency of the employee */
  travelFrequency: Scalars['String'];
  /** If the employee travels internationally */
  travelInternationally?: InputMaybe<Scalars['Boolean']>;
  /** The travel location of the employee */
  travelLocation: Scalars['String'];
  /** The travel purpose of the employee */
  travelPurpose: Scalars['String'];
};

/** A list of employees who use tools */
export type EmployeesWhoUseToolsInput = {
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** The first name of the employee */
  firstName?: InputMaybe<Scalars['String']>;
  /** The hardware names used by employee */
  hardwareNames: Scalars['String'];
  /** The last name of the employee */
  lastName?: InputMaybe<Scalars['String']>;
  /** The middle of the employee */
  middleName?: InputMaybe<Scalars['String']>;
};

/** A list of employees who work on ladders */
export type EmployeesWhoWorkOnLaddersInput = {
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** The description of a ladder an employee uses */
  laddersDescription?: InputMaybe<Scalars['String']>;
};

/** A list of employees who work underground */
export type EmployeesWhoWorkUndergroundInput = {
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** The type of underground work an employee does */
  undergroundDescription?: InputMaybe<Scalars['String']>;
};

/** The nested json data for a prospect's company epli */
export type EpliInput = {
  beenSuedFormerEmp?: InputMaybe<Scalars['Boolean']>;
  claimDetails?: InputMaybe<Scalars['String']>;
  hasPolicy?: InputMaybe<Scalars['Boolean']>;
  noEpliLossRunsReportOtherReason?: InputMaybe<Scalars['String']>;
  noEpliLossRunsReportReason?: InputMaybe<Scalars['String']>;
  offeredSeverancePackages?: InputMaybe<Scalars['Boolean']>;
  overTwentyFiveEe?: InputMaybe<Scalars['Boolean']>;
  receivedClaims?: InputMaybe<Scalars['Boolean']>;
  receivedEpliAllegations?: InputMaybe<Scalars['Boolean']>;
};

/** Enum representing the genders that can be submitted */
export enum GenderTypeEnum {
  Female = 'FEMALE',
  Male = 'MALE'
}

/** The employee's current health insurance plan information */
export type HealthInsuranceInfoInput = {
  /** Currently enrolled health insurance tier for member */
  currentEnrollmentTier?: InputMaybe<PlanTierEnum>;
  /** Monthly premium amount for member if they currently are subscribed for health insurance */
  currentMonthlyPremium?: InputMaybe<Scalars['Float']>;
  /** Name of the current heath insurance plan if subscribed to one */
  currentPlanName?: InputMaybe<Scalars['String']>;
  /** An indicator or whether this individual expects health insurance coverage (or is waiving coverage). This is optional pending FE changes. */
  isWaiving?: InputMaybe<Scalars['Boolean']>;
  /** Monthly premium amount following the next renewal with current plan */
  monthlyPremiumPostRenewal?: InputMaybe<Scalars['Float']>;
};

/** Enum representing the various health care carriers that can be submitted */
export enum HealthcareCarrierTypeEnum {
  Aetna = 'AETNA',
  AnthemHcsc = 'ANTHEM_HCSC',
  KaiserPermanent = 'KAISER_PERMANENT',
  Other = 'OTHER',
  UnitedHealthcare = 'UNITED_HEALTHCARE'
}

/** Enum representing the participant type that can be submitted */
export enum ParticipantTypeEnum {
  Child = 'CHILD',
  Employee = 'EMPLOYEE',
  Spouse = 'SPOUSE'
}

/** Enum representing the various plan tiers */
export enum PlanTierEnum {
  /** Employee and Child */
  EmployeeAndChild = 'EMPLOYEE_AND_CHILD',
  /** Employee and Family */
  EmployeeAndFamily = 'EMPLOYEE_AND_FAMILY',
  /** Employee and Spouse */
  EmployeeAndSpouse = 'EMPLOYEE_AND_SPOUSE',
  /** Employee Only */
  EmployeeOnly = 'EMPLOYEE_ONLY',
  /** Not Eligible for Benefits */
  NotEligibleForBenefits = 'NOT_ELIGIBLE_FOR_BENEFITS',
  /** Plans to Waive Benefits */
  PlansToWaiveBenefits = 'PLANS_TO_WAIVE_BENEFITS',
  /** Refusing Coverage */
  RefusingCoverage = 'REFUSING_COVERAGE',
  /** Waiting Period */
  WaitingPeriod = 'WAITING_PERIOD'
}

/** A entity related to an existing prospect */
export type RelatedEntityInput = {
  /** Related entity doing business as */
  dba: Scalars['String'];
  /** Description of the relationship with the related entity */
  description: Scalars['String'];
  /** The ein of the related entity */
  ein?: InputMaybe<Scalars['String']>;
  /** Does this enitity share employees with the parent prospect? */
  hasOverlappingEmployees: Scalars['Boolean'];
  /** Does this enitity have W2 employees? */
  hasW2Employees: Scalars['Boolean'];
  /** Is this enitity dependend on the parent prospect? */
  isDependent: Scalars['Boolean'];
  /** The name of the related entity */
  legalName: Scalars['String'];
  /** Does this enity share a location with the parent prospect? */
  sharesLocation: Scalars['Boolean'];
  /** The ID of the entity */
  uuid?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of ResetHealthInsInfo */
export type ResetHealthInsInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The uuid of the employee to reset */
  uuid: Scalars['ID'];
};

/** A list of underage and senior employees */
export type UnderageOrSeniorEmployeesInput = {
  /** The date of birth of the employee */
  dateOfBirth: Scalars['ISO8601Date'];
  /** The uuid of the employee */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** The first name of the employee */
  firstName?: InputMaybe<Scalars['String']>;
  /** The job title of the employee */
  jobTitle: Scalars['String'];
  /** The last name of the employee */
  lastName?: InputMaybe<Scalars['String']>;
  /** The middle of the employee */
  middleName?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateApplicationStep */
export type UpdateApplicationStepInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The step of the application form */
  step: Scalars['Int'];
  /** The uuid of the application to be update */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateBaseProspectProperties */
export type UpdateBaseProspectPropertiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The legal name of the prospective company */
  companyName?: InputMaybe<Scalars['String']>;
  /** DBA name of the business if applicable */
  dba?: InputMaybe<Scalars['String']>;
  /** EIN tax id of the business */
  ein?: InputMaybe<Scalars['String']>;
  /** CDMS Canonical ID of the company to modify */
  prospectCanonicalId?: InputMaybe<Scalars['String']>;
  /** SIC Code describes the primary business activity of a company */
  sicCode?: InputMaybe<Scalars['String']>;
  /** The uuid of the prospective company to update */
  uuid: Scalars['ID'];
  /** Website list of the business */
  website?: InputMaybe<Array<Scalars['String']>>;
  /** Year the business was founded */
  yearFounded?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateDependentCensuses */
export type UpdateDependentCensusesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Dependent censuses to be updated */
  dependentCensuses: Array<DependentCensusInput>;
  /** UUID of the the prospect */
  prospectId: Scalars['ID'];
};

/** Autogenerated input type of UpdateEmployeeCensus */
export type UpdateEmployeeCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Date of birth of the employee */
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']>;
  /** Email of the employee */
  email: Scalars['String'];
  /** Additional information about the employee and their work */
  employeeInformation?: InputMaybe<EmployeeInformationInput>;
  /** The type of employee */
  employeeType?: InputMaybe<Scalars['String']>;
  /** First name of the employee */
  firstName: Scalars['String'];
  /** Gender of the employee */
  gender?: InputMaybe<GenderTypeEnum>;
  /** Is this employee an employee of the company? */
  isCompanyEmployee?: InputMaybe<Scalars['Boolean']>;
  /** Is this employee also an owner of the company? */
  isCompanyOwner?: InputMaybe<Scalars['Boolean']>;
  /** Last name of the employee */
  lastName: Scalars['String'];
  /** Optional middle name of the employee */
  middleName?: InputMaybe<Scalars['String']>;
  /** UUID of the office location to associate with this employee */
  officeLocationId?: InputMaybe<Scalars['ID']>;
  /** Optional preferred name of the employee */
  preferredName?: InputMaybe<Scalars['String']>;
  /** Primary phone number of the employee */
  primaryPhone?: InputMaybe<Scalars['String']>;
  /** SSN of the employee */
  ssn?: InputMaybe<Scalars['String']>;
  /** The uuid of the employee to update */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateEmployeeInformation */
export type UpdateEmployeeInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The employee information to update in the Employee record */
  employeeInformation: EmployeeInformationInput;
  /** The uuid of the employee to update */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateHealthInsInfo */
export type UpdateHealthInsInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The health insurance plan information to update in the Employee record */
  healthInsInfo: HealthInsuranceInfoInput;
  /** The uuid of the employee to update */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateNoLossRunsReportReason */
export type UpdateNoLossRunsReportReasonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The user-provided reason why applicant did not upload a loss run report and selected the OTHER reason */
  noLossRunsReportOtherReason?: InputMaybe<Scalars['String']>;
  /** Reason why applicant did not upload a loss run report */
  noLossRunsReportReason?: InputMaybe<Scalars['String']>;
  /** The UUID of the prospect this information should be attached */
  prospectUuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateOfficeLocation */
export type UpdateOfficeLocationInput = {
  /** Address of office location */
  address1: Scalars['String'];
  /** Optional additional address information */
  address2?: InputMaybe<Scalars['String']>;
  /** City that this office location resides */
  city: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Specifies if this location is the primary headquarters of the organization */
  isHq?: InputMaybe<Scalars['Boolean']>;
  /** Unique value specifying a custom name for this office location */
  locationName?: InputMaybe<Scalars['String']>;
  /** The state abbreviation where this office location resides */
  state: Scalars['String'];
  /** The subdivision of an address (in the US, this will be a County). */
  subdivision?: InputMaybe<Scalars['String']>;
  /** An indicator for whether the subdivsion was validated */
  subdivisionValidated?: InputMaybe<Scalars['Boolean']>;
  /** The type of office location this record represents */
  type?: InputMaybe<Scalars['String']>;
  /** The uuid of the office location to update */
  uuid: Scalars['ID'];
  /** The zip code (with optional + 4 code) of this office location */
  zip: Scalars['String'];
};

/** Autogenerated input type of UpdateProspectBizActivities */
export type UpdateProspectBizActivitiesInput = {
  /** Business activity information */
  bizActivities: BizActivitiesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The UUID of the prospect this information should be attached */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateProspectCompanyInfo */
export type UpdateProspectCompanyInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** General information about the company */
  companyInfo: CompanyInfoInput;
  /** The UUID of the prospect this information should be attached */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateProspectEmployeeFlags */
export type UpdateProspectEmployeeFlagsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Additional information about the activities of the company's employees */
  employeeFlags: EmployeeFlagsInput;
  /** The UUID of the prospect this information should be attached */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateProspectEpli */
export type UpdateProspectEpliInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** EPLI information about the prospective company */
  epli: EpliInput;
  /** The UUID of the prospect this information should be attached */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateProspectHealthInsuranceInfo */
export type UpdateProspectHealthInsuranceInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** General information about the Health Insurance */
  healthInsuranceInfo: CompanyHealthInsuranceInfoInput;
  /** The UUID of the prospect this information should be attached */
  uuid: Scalars['ID'];
};

/** Autogenerated input type of UpdateRelatedEntities */
export type UpdateRelatedEntitiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The uuid of the related prospect */
  prospectUuid: Scalars['ID'];
  /** The related entities to update */
  relatedEntities: Array<RelatedEntityInput>;
};

/** Autogenerated input type of UpsertCobraCensus */
export type UpsertCobraCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Cobra censuses to be upserted */
  cobraCensuses: Array<CobraCensusInput>;
  /** UUID of the prospective company */
  prospectId: Scalars['ID'];
};

/** Autogenerated input type of UpsertDependentAndEmployeeCensus */
export type UpsertDependentAndEmployeeCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Dependent & employee censuses to be upserted */
  dependentCensuses: Array<DependentCensusInput>;
  /** UUID of the the prospect */
  prospectId: Scalars['ID'];
  /** The source of the employee census record */
  source?: InputMaybe<EmployeeCensusSourceEnum>;
};

/** Autogenerated input type of UpsertHealthInsEmployeeCensus */
export type UpsertHealthInsEmployeeCensusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Employee health insurance censuses to be created */
  employeeHealthCensus: DependentCensusInput;
  /** UUID of the the prospect */
  prospectId: Scalars['ID'];
  /** The source of the employee census record */
  source?: InputMaybe<EmployeeCensusSourceEnum>;
};


export const DeleteCobraParticipantDocument = gql`
    mutation DeleteCobraParticipant($uuid: ID!) {
  deleteCobraCensus(input: {uuid: $uuid}) {
    uuid
  }
}
    `;
export type DeleteCobraParticipantMutationFn = Apollo.MutationFunction<DeleteCobraParticipantMutation, DeleteCobraParticipantMutationVariables>;

/**
 * __useDeleteCobraParticipantMutation__
 *
 * To run a mutation, you first call `useDeleteCobraParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCobraParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCobraParticipantMutation, { data, loading, error }] = useDeleteCobraParticipantMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteCobraParticipantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCobraParticipantMutation, DeleteCobraParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCobraParticipantMutation, DeleteCobraParticipantMutationVariables>(DeleteCobraParticipantDocument, options);
      }
export type DeleteCobraParticipantMutationHookResult = ReturnType<typeof useDeleteCobraParticipantMutation>;
export type DeleteCobraParticipantMutationResult = Apollo.MutationResult<DeleteCobraParticipantMutation>;
export type DeleteCobraParticipantMutationOptions = Apollo.BaseMutationOptions<DeleteCobraParticipantMutation, DeleteCobraParticipantMutationVariables>;
export const GetCobraParticipantsDocument = gql`
    query GetCobraParticipants($uuid: ID!, $appType: ApplicationTypeEnum!) {
  prospect(uuid: $uuid) {
    healthInsuranceInformation {
      cobraUsage
      currentlyOfferHealthInsurance
    }
    applications(applicationFilter: {type: $appType}) {
      uuid
      step
    }
    cobraCensuses {
      cobraDependents {
        uuid
        firstName
        lastName
        participantType
        gender
        dateOfBirth
        homeZip
        healthInsInfo {
          currentEnrollmentTier
          currentMonthlyPremium
          currentPlanName
          monthlyPremiumPostRenewal
        }
      }
      uuid
      firstName
      lastName
      participantType
      gender
      dateOfBirth
      homeZip
      healthInsInfo {
        currentEnrollmentTier
        currentMonthlyPremium
        currentPlanName
        monthlyPremiumPostRenewal
      }
    }
  }
}
    `;

/**
 * __useGetCobraParticipantsQuery__
 *
 * To run a query within a React component, call `useGetCobraParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCobraParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCobraParticipantsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetCobraParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetCobraParticipantsQuery, GetCobraParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCobraParticipantsQuery, GetCobraParticipantsQueryVariables>(GetCobraParticipantsDocument, options);
      }
export function useGetCobraParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCobraParticipantsQuery, GetCobraParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCobraParticipantsQuery, GetCobraParticipantsQueryVariables>(GetCobraParticipantsDocument, options);
        }
export type GetCobraParticipantsQueryHookResult = ReturnType<typeof useGetCobraParticipantsQuery>;
export type GetCobraParticipantsLazyQueryHookResult = ReturnType<typeof useGetCobraParticipantsLazyQuery>;
export type GetCobraParticipantsQueryResult = Apollo.QueryResult<GetCobraParticipantsQuery, GetCobraParticipantsQueryVariables>;
export const UpsertCobraParticipantsDocument = gql`
    mutation UpsertCobraParticipants($prospectId: ID!, $cobraCensuses: [CobraCensusInput!]!) {
  upsertCobraCensus(
    input: {prospectId: $prospectId, cobraCensuses: $cobraCensuses}
  ) {
    uuids
  }
}
    `;
export type UpsertCobraParticipantsMutationFn = Apollo.MutationFunction<UpsertCobraParticipantsMutation, UpsertCobraParticipantsMutationVariables>;

/**
 * __useUpsertCobraParticipantsMutation__
 *
 * To run a mutation, you first call `useUpsertCobraParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCobraParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCobraParticipantsMutation, { data, loading, error }] = useUpsertCobraParticipantsMutation({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      cobraCensuses: // value for 'cobraCensuses'
 *   },
 * });
 */
export function useUpsertCobraParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCobraParticipantsMutation, UpsertCobraParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCobraParticipantsMutation, UpsertCobraParticipantsMutationVariables>(UpsertCobraParticipantsDocument, options);
      }
export type UpsertCobraParticipantsMutationHookResult = ReturnType<typeof useUpsertCobraParticipantsMutation>;
export type UpsertCobraParticipantsMutationResult = Apollo.MutationResult<UpsertCobraParticipantsMutation>;
export type UpsertCobraParticipantsMutationOptions = Apollo.BaseMutationOptions<UpsertCobraParticipantsMutation, UpsertCobraParticipantsMutationVariables>;
export const CreateDependentCensusesDocument = gql`
    mutation CreateDependentCensuses($dependentCensuses: [DependentCensusInput!]!, $prospectId: ID!) {
  createDependentCensuses(
    input: {dependentCensuses: $dependentCensuses, prospectId: $prospectId}
  ) {
    uuids
  }
}
    `;
export type CreateDependentCensusesMutationFn = Apollo.MutationFunction<CreateDependentCensusesMutation, CreateDependentCensusesMutationVariables>;

/**
 * __useCreateDependentCensusesMutation__
 *
 * To run a mutation, you first call `useCreateDependentCensusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDependentCensusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDependentCensusesMutation, { data, loading, error }] = useCreateDependentCensusesMutation({
 *   variables: {
 *      dependentCensuses: // value for 'dependentCensuses'
 *      prospectId: // value for 'prospectId'
 *   },
 * });
 */
export function useCreateDependentCensusesMutation(baseOptions?: Apollo.MutationHookOptions<CreateDependentCensusesMutation, CreateDependentCensusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDependentCensusesMutation, CreateDependentCensusesMutationVariables>(CreateDependentCensusesDocument, options);
      }
export type CreateDependentCensusesMutationHookResult = ReturnType<typeof useCreateDependentCensusesMutation>;
export type CreateDependentCensusesMutationResult = Apollo.MutationResult<CreateDependentCensusesMutation>;
export type CreateDependentCensusesMutationOptions = Apollo.BaseMutationOptions<CreateDependentCensusesMutation, CreateDependentCensusesMutationVariables>;
export const DeleteDependentCensusDocument = gql`
    mutation DeleteDependentCensus($uuid: ID!, $participantType: ParticipantTypeEnum!) {
  deleteDependentCensus(input: {uuid: $uuid, participantType: $participantType}) {
    uuid
  }
}
    `;
export type DeleteDependentCensusMutationFn = Apollo.MutationFunction<DeleteDependentCensusMutation, DeleteDependentCensusMutationVariables>;

/**
 * __useDeleteDependentCensusMutation__
 *
 * To run a mutation, you first call `useDeleteDependentCensusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDependentCensusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDependentCensusMutation, { data, loading, error }] = useDeleteDependentCensusMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      participantType: // value for 'participantType'
 *   },
 * });
 */
export function useDeleteDependentCensusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDependentCensusMutation, DeleteDependentCensusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDependentCensusMutation, DeleteDependentCensusMutationVariables>(DeleteDependentCensusDocument, options);
      }
export type DeleteDependentCensusMutationHookResult = ReturnType<typeof useDeleteDependentCensusMutation>;
export type DeleteDependentCensusMutationResult = Apollo.MutationResult<DeleteDependentCensusMutation>;
export type DeleteDependentCensusMutationOptions = Apollo.BaseMutationOptions<DeleteDependentCensusMutation, DeleteDependentCensusMutationVariables>;
export const DeleteMdvDependentCensusDocument = gql`
    mutation DeleteMdvDependentCensus($uuids: [ID!]!, $prospectId: ID!) {
  deleteDependentCensuses(input: {uuids: $uuids, prospectId: $prospectId}) {
    uuids
  }
}
    `;
export type DeleteMdvDependentCensusMutationFn = Apollo.MutationFunction<DeleteMdvDependentCensusMutation, DeleteMdvDependentCensusMutationVariables>;

/**
 * __useDeleteMdvDependentCensusMutation__
 *
 * To run a mutation, you first call `useDeleteMdvDependentCensusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMdvDependentCensusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMdvDependentCensusMutation, { data, loading, error }] = useDeleteMdvDependentCensusMutation({
 *   variables: {
 *      uuids: // value for 'uuids'
 *      prospectId: // value for 'prospectId'
 *   },
 * });
 */
export function useDeleteMdvDependentCensusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMdvDependentCensusMutation, DeleteMdvDependentCensusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMdvDependentCensusMutation, DeleteMdvDependentCensusMutationVariables>(DeleteMdvDependentCensusDocument, options);
      }
export type DeleteMdvDependentCensusMutationHookResult = ReturnType<typeof useDeleteMdvDependentCensusMutation>;
export type DeleteMdvDependentCensusMutationResult = Apollo.MutationResult<DeleteMdvDependentCensusMutation>;
export type DeleteMdvDependentCensusMutationOptions = Apollo.BaseMutationOptions<DeleteMdvDependentCensusMutation, DeleteMdvDependentCensusMutationVariables>;
export const GetCurrentEmployeesDocument = gql`
    query GetCurrentEmployees($uuid: ID!, $appType: ApplicationTypeEnum!) {
  prospect(uuid: $uuid) {
    healthInsuranceInformation {
      cobraUsage
      currentlyOfferHealthInsurance
    }
    applications(applicationFilter: {type: $appType}) {
      uuid
      status
      step
    }
    workersCompApplication: applications(applicationFilter: {type: WORKERS_COMP}) {
      status
      uuid
    }
    employeeCensuses {
      uuid
      source
      firstName
      lastName
      gender
      dateOfBirth
      email
      homeZip
      homeState
      employeeInformation {
        department
        isPaid
      }
      healthInsInfo {
        currentPlanName
        currentEnrollmentTier
        currentMonthlyPremium
        monthlyPremiumPostRenewal
        isWaiving
      }
      isCompanyOwner
      isCompanyEmployee
      dependentCensuses {
        employeeCensusId
        uuid
        firstName
        lastName
        gender
        dateOfBirth
        homeZip
        homeState
        participantType
      }
    }
  }
}
    `;

/**
 * __useGetCurrentEmployeesQuery__
 *
 * To run a query within a React component, call `useGetCurrentEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEmployeesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetCurrentEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentEmployeesQuery, GetCurrentEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentEmployeesQuery, GetCurrentEmployeesQueryVariables>(GetCurrentEmployeesDocument, options);
      }
export function useGetCurrentEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentEmployeesQuery, GetCurrentEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentEmployeesQuery, GetCurrentEmployeesQueryVariables>(GetCurrentEmployeesDocument, options);
        }
export type GetCurrentEmployeesQueryHookResult = ReturnType<typeof useGetCurrentEmployeesQuery>;
export type GetCurrentEmployeesLazyQueryHookResult = ReturnType<typeof useGetCurrentEmployeesLazyQuery>;
export type GetCurrentEmployeesQueryResult = Apollo.QueryResult<GetCurrentEmployeesQuery, GetCurrentEmployeesQueryVariables>;
export const UpsertDependentAndEmployeeCensusDocument = gql`
    mutation UpsertDependentAndEmployeeCensus($prospectId: ID!, $dependentCensuses: [DependentCensusInput!]!, $source: EmployeeCensusSourceEnum) {
  upsertDependentAndEmployeeCensus(
    input: {prospectId: $prospectId, dependentCensuses: $dependentCensuses, source: $source}
  ) {
    uuids
  }
}
    `;
export type UpsertDependentAndEmployeeCensusMutationFn = Apollo.MutationFunction<UpsertDependentAndEmployeeCensusMutation, UpsertDependentAndEmployeeCensusMutationVariables>;

/**
 * __useUpsertDependentAndEmployeeCensusMutation__
 *
 * To run a mutation, you first call `useUpsertDependentAndEmployeeCensusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDependentAndEmployeeCensusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDependentAndEmployeeCensusMutation, { data, loading, error }] = useUpsertDependentAndEmployeeCensusMutation({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      dependentCensuses: // value for 'dependentCensuses'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useUpsertDependentAndEmployeeCensusMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDependentAndEmployeeCensusMutation, UpsertDependentAndEmployeeCensusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDependentAndEmployeeCensusMutation, UpsertDependentAndEmployeeCensusMutationVariables>(UpsertDependentAndEmployeeCensusDocument, options);
      }
export type UpsertDependentAndEmployeeCensusMutationHookResult = ReturnType<typeof useUpsertDependentAndEmployeeCensusMutation>;
export type UpsertDependentAndEmployeeCensusMutationResult = Apollo.MutationResult<UpsertDependentAndEmployeeCensusMutation>;
export type UpsertDependentAndEmployeeCensusMutationOptions = Apollo.BaseMutationOptions<UpsertDependentAndEmployeeCensusMutation, UpsertDependentAndEmployeeCensusMutationVariables>;
export const UpdateDependentCensusesDocument = gql`
    mutation UpdateDependentCensuses($dependentCensuses: [DependentCensusInput!]!, $prospectId: ID!) {
  updateDependentCensuses(
    input: {dependentCensuses: $dependentCensuses, prospectId: $prospectId}
  ) {
    uuids
  }
}
    `;
export type UpdateDependentCensusesMutationFn = Apollo.MutationFunction<UpdateDependentCensusesMutation, UpdateDependentCensusesMutationVariables>;

/**
 * __useUpdateDependentCensusesMutation__
 *
 * To run a mutation, you first call `useUpdateDependentCensusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDependentCensusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDependentCensusesMutation, { data, loading, error }] = useUpdateDependentCensusesMutation({
 *   variables: {
 *      dependentCensuses: // value for 'dependentCensuses'
 *      prospectId: // value for 'prospectId'
 *   },
 * });
 */
export function useUpdateDependentCensusesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDependentCensusesMutation, UpdateDependentCensusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDependentCensusesMutation, UpdateDependentCensusesMutationVariables>(UpdateDependentCensusesDocument, options);
      }
export type UpdateDependentCensusesMutationHookResult = ReturnType<typeof useUpdateDependentCensusesMutation>;
export type UpdateDependentCensusesMutationResult = Apollo.MutationResult<UpdateDependentCensusesMutation>;
export type UpdateDependentCensusesMutationOptions = Apollo.BaseMutationOptions<UpdateDependentCensusesMutation, UpdateDependentCensusesMutationVariables>;
export const GetCurrentInsuranceDocument = gql`
    query GetCurrentInsurance($uuid: ID!, $appType: ApplicationTypeEnum!) {
  prospect(uuid: $uuid) {
    healthInsuranceApplication: applications(applicationFilter: {type: $appType}) {
      step
      uuid
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    workersCompApplication: applications(applicationFilter: {type: WORKERS_COMP}) {
      step
      uuid
    }
    yearFounded
    sicCode
    dba
    companyName
    healthInsuranceInformation {
      cobraUsage
      currentlyOfferHealthInsurance
      currentRenewalDate
      controlledGroup
      startingCoverageDate
      isOnPeo
      currentPeo
      currentPeoOther
    }
  }
}
    `;

/**
 * __useGetCurrentInsuranceQuery__
 *
 * To run a query within a React component, call `useGetCurrentInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentInsuranceQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetCurrentInsuranceQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentInsuranceQuery, GetCurrentInsuranceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentInsuranceQuery, GetCurrentInsuranceQueryVariables>(GetCurrentInsuranceDocument, options);
      }
export function useGetCurrentInsuranceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentInsuranceQuery, GetCurrentInsuranceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentInsuranceQuery, GetCurrentInsuranceQueryVariables>(GetCurrentInsuranceDocument, options);
        }
export type GetCurrentInsuranceQueryHookResult = ReturnType<typeof useGetCurrentInsuranceQuery>;
export type GetCurrentInsuranceLazyQueryHookResult = ReturnType<typeof useGetCurrentInsuranceLazyQuery>;
export type GetCurrentInsuranceQueryResult = Apollo.QueryResult<GetCurrentInsuranceQuery, GetCurrentInsuranceQueryVariables>;
export const UpdateCurrentInsuranceDocument = gql`
    mutation UpdateCurrentInsurance($uuid: ID!, $controlledGroup: Boolean, $startingCoverageDate: ISO8601Date, $isOnPeo: Boolean, $currentPeo: String, $currentPeoOther: String) {
  updateProspectHealthInsuranceInfo(
    input: {uuid: $uuid, healthInsuranceInfo: {controlledGroup: $controlledGroup, startingCoverageDate: $startingCoverageDate, isOnPeo: $isOnPeo, currentPeo: $currentPeo, currentPeoOther: $currentPeoOther}}
  ) {
    uuid
  }
}
    `;
export type UpdateCurrentInsuranceMutationFn = Apollo.MutationFunction<UpdateCurrentInsuranceMutation, UpdateCurrentInsuranceMutationVariables>;

/**
 * __useUpdateCurrentInsuranceMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentInsuranceMutation, { data, loading, error }] = useUpdateCurrentInsuranceMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      controlledGroup: // value for 'controlledGroup'
 *      startingCoverageDate: // value for 'startingCoverageDate'
 *      isOnPeo: // value for 'isOnPeo'
 *      currentPeo: // value for 'currentPeo'
 *      currentPeoOther: // value for 'currentPeoOther'
 *   },
 * });
 */
export function useUpdateCurrentInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentInsuranceMutation, UpdateCurrentInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentInsuranceMutation, UpdateCurrentInsuranceMutationVariables>(UpdateCurrentInsuranceDocument, options);
      }
export type UpdateCurrentInsuranceMutationHookResult = ReturnType<typeof useUpdateCurrentInsuranceMutation>;
export type UpdateCurrentInsuranceMutationResult = Apollo.MutationResult<UpdateCurrentInsuranceMutation>;
export type UpdateCurrentInsuranceMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentInsuranceMutation, UpdateCurrentInsuranceMutationVariables>;
export const UpdateProspectInfoDocument = gql`
    mutation UpdateProspectInfo($uuid: ID!, $yearFounded: Int, $sicCode: String, $companyName: String, $dba: String) {
  updateBaseProspect(
    input: {uuid: $uuid, yearFounded: $yearFounded, sicCode: $sicCode, companyName: $companyName, dba: $dba}
  ) {
    uuid
  }
}
    `;
export type UpdateProspectInfoMutationFn = Apollo.MutationFunction<UpdateProspectInfoMutation, UpdateProspectInfoMutationVariables>;

/**
 * __useUpdateProspectInfoMutation__
 *
 * To run a mutation, you first call `useUpdateProspectInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProspectInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProspectInfoMutation, { data, loading, error }] = useUpdateProspectInfoMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      yearFounded: // value for 'yearFounded'
 *      sicCode: // value for 'sicCode'
 *      companyName: // value for 'companyName'
 *      dba: // value for 'dba'
 *   },
 * });
 */
export function useUpdateProspectInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProspectInfoMutation, UpdateProspectInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProspectInfoMutation, UpdateProspectInfoMutationVariables>(UpdateProspectInfoDocument, options);
      }
export type UpdateProspectInfoMutationHookResult = ReturnType<typeof useUpdateProspectInfoMutation>;
export type UpdateProspectInfoMutationResult = Apollo.MutationResult<UpdateProspectInfoMutation>;
export type UpdateProspectInfoMutationOptions = Apollo.BaseMutationOptions<UpdateProspectInfoMutation, UpdateProspectInfoMutationVariables>;
export const CreateHealthApplicationDocument = gql`
    mutation createHealthApplication($prospectId: ID!, $appType: ApplicationTypeEnum!, $prospectCanonicalId: String, $memberUuid: ID, $applicationSteps: [String!]) {
  createApplication(
    input: {prospectId: $prospectId, appType: $appType, prospectCanonicalId: $prospectCanonicalId, createdBy: $memberUuid, applicationSteps: $applicationSteps}
  ) {
    uuid
  }
}
    `;
export type CreateHealthApplicationMutationFn = Apollo.MutationFunction<CreateHealthApplicationMutation, CreateHealthApplicationMutationVariables>;

/**
 * __useCreateHealthApplicationMutation__
 *
 * To run a mutation, you first call `useCreateHealthApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthApplicationMutation, { data, loading, error }] = useCreateHealthApplicationMutation({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      appType: // value for 'appType'
 *      prospectCanonicalId: // value for 'prospectCanonicalId'
 *      memberUuid: // value for 'memberUuid'
 *      applicationSteps: // value for 'applicationSteps'
 *   },
 * });
 */
export function useCreateHealthApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateHealthApplicationMutation, CreateHealthApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHealthApplicationMutation, CreateHealthApplicationMutationVariables>(CreateHealthApplicationDocument, options);
      }
export type CreateHealthApplicationMutationHookResult = ReturnType<typeof useCreateHealthApplicationMutation>;
export type CreateHealthApplicationMutationResult = Apollo.MutationResult<CreateHealthApplicationMutation>;
export type CreateHealthApplicationMutationOptions = Apollo.BaseMutationOptions<CreateHealthApplicationMutation, CreateHealthApplicationMutationVariables>;
export const GetHealthAppStepDocument = gql`
    query GetHealthAppStep($uuid: ID!, $appType: ApplicationTypeEnum!) {
  prospect(uuid: $uuid) {
    healthInsuranceInformation {
      isCoverageEligible
      cobraUsage
      currentlyOfferHealthInsurance
    }
    applications(applicationFilter: {type: $appType}) {
      uuid
      step
      status
      flowVersion
      createdAt
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    cobraCensuses {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetHealthAppStepQuery__
 *
 * To run a query within a React component, call `useGetHealthAppStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthAppStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthAppStepQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetHealthAppStepQuery(baseOptions: Apollo.QueryHookOptions<GetHealthAppStepQuery, GetHealthAppStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthAppStepQuery, GetHealthAppStepQueryVariables>(GetHealthAppStepDocument, options);
      }
export function useGetHealthAppStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthAppStepQuery, GetHealthAppStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthAppStepQuery, GetHealthAppStepQueryVariables>(GetHealthAppStepDocument, options);
        }
export type GetHealthAppStepQueryHookResult = ReturnType<typeof useGetHealthAppStepQuery>;
export type GetHealthAppStepLazyQueryHookResult = ReturnType<typeof useGetHealthAppStepLazyQuery>;
export type GetHealthAppStepQueryResult = Apollo.QueryResult<GetHealthAppStepQuery, GetHealthAppStepQueryVariables>;
export const GetCurrentCoverageDocument = gql`
    query GetCurrentCoverage($uuid: ID!, $appType: ApplicationTypeEnum!) {
  prospect(uuid: $uuid) {
    sicCode
    healthInsuranceInformation {
      isCoverageEligible
      currentlyOfferHealthInsurance
      currentCarrier
      currentCarrierOther
      currentRenewalDate
      cobraUsage
      cobraUsers
      benefitEligibleEmployees
      controlledGroup
      isOnPeo
      currentPeo
      currentPeoOther
      startingCoverageDate
    }
    applications(applicationFilter: {type: $appType}) {
      uuid
      step
    }
  }
}
    `;

/**
 * __useGetCurrentCoverageQuery__
 *
 * To run a query within a React component, call `useGetCurrentCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCoverageQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetCurrentCoverageQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentCoverageQuery, GetCurrentCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCoverageQuery, GetCurrentCoverageQueryVariables>(GetCurrentCoverageDocument, options);
      }
export function useGetCurrentCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCoverageQuery, GetCurrentCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCoverageQuery, GetCurrentCoverageQueryVariables>(GetCurrentCoverageDocument, options);
        }
export type GetCurrentCoverageQueryHookResult = ReturnType<typeof useGetCurrentCoverageQuery>;
export type GetCurrentCoverageLazyQueryHookResult = ReturnType<typeof useGetCurrentCoverageLazyQuery>;
export type GetCurrentCoverageQueryResult = Apollo.QueryResult<GetCurrentCoverageQuery, GetCurrentCoverageQueryVariables>;
export const UpdateCurrentCoverageDocument = gql`
    mutation UpdateCurrentCoverage($uuid: ID!, $benefitEligibleEmployees: Int, $cobraUsage: Boolean, $cobraUsers: Int, $currentCarrier: HealthcareCarrierTypeEnum, $currentCarrierOther: String, $currentRenewalDate: ISO8601Date, $currentlyOfferHealthInsurance: Boolean, $isOnPeo: Boolean, $currentPeo: String, $currentPeoOther: String, $controlledGroup: Boolean, $startingCoverageDate: ISO8601Date) {
  updateProspectHealthInsuranceInfo(
    input: {uuid: $uuid, healthInsuranceInfo: {benefitEligibleEmployees: $benefitEligibleEmployees, cobraUsage: $cobraUsage, cobraUsers: $cobraUsers, currentCarrier: $currentCarrier, currentCarrierOther: $currentCarrierOther, currentRenewalDate: $currentRenewalDate, currentlyOfferHealthInsurance: $currentlyOfferHealthInsurance, isOnPeo: $isOnPeo, currentPeo: $currentPeo, currentPeoOther: $currentPeoOther, controlledGroup: $controlledGroup, startingCoverageDate: $startingCoverageDate}}
  ) {
    uuid
    isCoverageEligible
    cobraUsage
    currentlyOfferHealthInsurance
  }
}
    `;
export type UpdateCurrentCoverageMutationFn = Apollo.MutationFunction<UpdateCurrentCoverageMutation, UpdateCurrentCoverageMutationVariables>;

/**
 * __useUpdateCurrentCoverageMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentCoverageMutation, { data, loading, error }] = useUpdateCurrentCoverageMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      benefitEligibleEmployees: // value for 'benefitEligibleEmployees'
 *      cobraUsage: // value for 'cobraUsage'
 *      cobraUsers: // value for 'cobraUsers'
 *      currentCarrier: // value for 'currentCarrier'
 *      currentCarrierOther: // value for 'currentCarrierOther'
 *      currentRenewalDate: // value for 'currentRenewalDate'
 *      currentlyOfferHealthInsurance: // value for 'currentlyOfferHealthInsurance'
 *      isOnPeo: // value for 'isOnPeo'
 *      currentPeo: // value for 'currentPeo'
 *      currentPeoOther: // value for 'currentPeoOther'
 *      controlledGroup: // value for 'controlledGroup'
 *      startingCoverageDate: // value for 'startingCoverageDate'
 *   },
 * });
 */
export function useUpdateCurrentCoverageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentCoverageMutation, UpdateCurrentCoverageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentCoverageMutation, UpdateCurrentCoverageMutationVariables>(UpdateCurrentCoverageDocument, options);
      }
export type UpdateCurrentCoverageMutationHookResult = ReturnType<typeof useUpdateCurrentCoverageMutation>;
export type UpdateCurrentCoverageMutationResult = Apollo.MutationResult<UpdateCurrentCoverageMutation>;
export type UpdateCurrentCoverageMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentCoverageMutation, UpdateCurrentCoverageMutationVariables>;
export const GetPrimaryAddressDocument = gql`
    query GetPrimaryAddress($uuid: ID!, $appType: ApplicationTypeEnum!) {
  prospect(uuid: $uuid) {
    healthInsuranceInformation {
      isCoverageEligible
    }
    applications(applicationFilter: {type: $appType}) {
      uuid
      step
      createdAt
    }
    officeLocations {
      address1
      address2
      city
      locationName
      state
      zip
      autoValidated
      uuid
      isHq
      subdivision
    }
  }
}
    `;

/**
 * __useGetPrimaryAddressQuery__
 *
 * To run a query within a React component, call `useGetPrimaryAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimaryAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimaryAddressQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetPrimaryAddressQuery(baseOptions: Apollo.QueryHookOptions<GetPrimaryAddressQuery, GetPrimaryAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrimaryAddressQuery, GetPrimaryAddressQueryVariables>(GetPrimaryAddressDocument, options);
      }
export function useGetPrimaryAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrimaryAddressQuery, GetPrimaryAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrimaryAddressQuery, GetPrimaryAddressQueryVariables>(GetPrimaryAddressDocument, options);
        }
export type GetPrimaryAddressQueryHookResult = ReturnType<typeof useGetPrimaryAddressQuery>;
export type GetPrimaryAddressLazyQueryHookResult = ReturnType<typeof useGetPrimaryAddressLazyQuery>;
export type GetPrimaryAddressQueryResult = Apollo.QueryResult<GetPrimaryAddressQuery, GetPrimaryAddressQueryVariables>;
export const GetCoverageEligibilityDocument = gql`
    query GetCoverageEligibility($uuid: ID!, $appType: ApplicationTypeEnum!) {
  prospect(uuid: $uuid) {
    healthInsuranceInformation {
      isCoverageEligible
    }
    applications(applicationFilter: {type: $appType}) {
      uuid
      step
    }
  }
}
    `;

/**
 * __useGetCoverageEligibilityQuery__
 *
 * To run a query within a React component, call `useGetCoverageEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoverageEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoverageEligibilityQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetCoverageEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GetCoverageEligibilityQuery, GetCoverageEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoverageEligibilityQuery, GetCoverageEligibilityQueryVariables>(GetCoverageEligibilityDocument, options);
      }
export function useGetCoverageEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoverageEligibilityQuery, GetCoverageEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoverageEligibilityQuery, GetCoverageEligibilityQueryVariables>(GetCoverageEligibilityDocument, options);
        }
export type GetCoverageEligibilityQueryHookResult = ReturnType<typeof useGetCoverageEligibilityQuery>;
export type GetCoverageEligibilityLazyQueryHookResult = ReturnType<typeof useGetCoverageEligibilityLazyQuery>;
export type GetCoverageEligibilityQueryResult = Apollo.QueryResult<GetCoverageEligibilityQuery, GetCoverageEligibilityQueryVariables>;
export const GetBusinessAttributesDocument = gql`
    query GetBusinessAttributes($uuid: ID!) {
  prospect(uuid: $uuid) {
    applications(applicationFilter: {type: WORKERS_COMP}) {
      uuid
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    companyInformation {
      bizActivities {
        hasVolunteerAccidentPolicy
        hasPriorCarriers
        priorCarriers
        hasHadWorkersCompPolicy
        hasPastDuePremiums
        beenCancelled
        policyCancelledReason
        beenDeclined
        sponsorSportsTeams
        hasTaxLeinBankrupcy
        offerHealthInsurance
        ownAircraftWatercraft
        use3rdPartyVendors
        thirdPartyDetails1
        thirdPartyDetails2
        thirdPartyDetails3
        thirdPartyDetails4
        hasVolunteers
        numberVolunteers
        volunteerActivities
        volunteerTravel
        hazardousMats
        hasWrittenSafteyProg
      }
    }
    website
  }
}
    `;

/**
 * __useGetBusinessAttributesQuery__
 *
 * To run a query within a React component, call `useGetBusinessAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAttributesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetBusinessAttributesQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessAttributesQuery, GetBusinessAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessAttributesQuery, GetBusinessAttributesQueryVariables>(GetBusinessAttributesDocument, options);
      }
export function useGetBusinessAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessAttributesQuery, GetBusinessAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessAttributesQuery, GetBusinessAttributesQueryVariables>(GetBusinessAttributesDocument, options);
        }
export type GetBusinessAttributesQueryHookResult = ReturnType<typeof useGetBusinessAttributesQuery>;
export type GetBusinessAttributesLazyQueryHookResult = ReturnType<typeof useGetBusinessAttributesLazyQuery>;
export type GetBusinessAttributesQueryResult = Apollo.QueryResult<GetBusinessAttributesQuery, GetBusinessAttributesQueryVariables>;
export const UpdateBusinessAttributesDocument = gql`
    mutation UpdateBusinessAttributes($uuid: ID!, $hasTaxLeinBankrupcy: Boolean, $hasWrittenSafteyProg: Boolean, $hazardousMats: Boolean, $offerHealthInsurance: Boolean, $ownAircraftWatercraft: Boolean, $sponsorSportsTeams: Boolean, $use3rdPartyVendors: Boolean, $hasVolunteers: Boolean, $numberVolunteers: Int, $volunteerActivities: String, $volunteerTravel: Boolean, $beenCancelled: Boolean, $beenDeclined: Boolean, $hasPastDuePremiums: Boolean, $hasHadWorkersCompPolicy: Boolean, $hasPriorCarriers: Boolean, $policyCancelledReason: String, $priorCarriers: String, $thirdPartyDetails1: String, $thirdPartyDetails2: String, $thirdPartyDetails3: String, $thirdPartyDetails4: String, $hasVolunteerAccidentPolicy: Boolean) {
  updateProspectBizActivities(
    input: {uuid: $uuid, bizActivities: {hasTaxLeinBankrupcy: $hasTaxLeinBankrupcy, hasWrittenSafteyProg: $hasWrittenSafteyProg, hazardousMats: $hazardousMats, offerHealthInsurance: $offerHealthInsurance, ownAircraftWatercraft: $ownAircraftWatercraft, sponsorSportsTeams: $sponsorSportsTeams, hasHadWorkersCompPolicy: $hasHadWorkersCompPolicy, use3rdPartyVendors: $use3rdPartyVendors, hasVolunteers: $hasVolunteers, numberVolunteers: $numberVolunteers, volunteerActivities: $volunteerActivities, volunteerTravel: $volunteerTravel, beenCancelled: $beenCancelled, beenDeclined: $beenDeclined, hasPastDuePremiums: $hasPastDuePremiums, hasPriorCarriers: $hasPriorCarriers, policyCancelledReason: $policyCancelledReason, priorCarriers: $priorCarriers, thirdPartyDetails1: $thirdPartyDetails1, thirdPartyDetails2: $thirdPartyDetails2, thirdPartyDetails3: $thirdPartyDetails3, thirdPartyDetails4: $thirdPartyDetails4, hasVolunteerAccidentPolicy: $hasVolunteerAccidentPolicy}}
  ) {
    uuid
  }
}
    `;
export type UpdateBusinessAttributesMutationFn = Apollo.MutationFunction<UpdateBusinessAttributesMutation, UpdateBusinessAttributesMutationVariables>;

/**
 * __useUpdateBusinessAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessAttributesMutation, { data, loading, error }] = useUpdateBusinessAttributesMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      hasTaxLeinBankrupcy: // value for 'hasTaxLeinBankrupcy'
 *      hasWrittenSafteyProg: // value for 'hasWrittenSafteyProg'
 *      hazardousMats: // value for 'hazardousMats'
 *      offerHealthInsurance: // value for 'offerHealthInsurance'
 *      ownAircraftWatercraft: // value for 'ownAircraftWatercraft'
 *      sponsorSportsTeams: // value for 'sponsorSportsTeams'
 *      use3rdPartyVendors: // value for 'use3rdPartyVendors'
 *      hasVolunteers: // value for 'hasVolunteers'
 *      numberVolunteers: // value for 'numberVolunteers'
 *      volunteerActivities: // value for 'volunteerActivities'
 *      volunteerTravel: // value for 'volunteerTravel'
 *      beenCancelled: // value for 'beenCancelled'
 *      beenDeclined: // value for 'beenDeclined'
 *      hasPastDuePremiums: // value for 'hasPastDuePremiums'
 *      hasHadWorkersCompPolicy: // value for 'hasHadWorkersCompPolicy'
 *      hasPriorCarriers: // value for 'hasPriorCarriers'
 *      policyCancelledReason: // value for 'policyCancelledReason'
 *      priorCarriers: // value for 'priorCarriers'
 *      thirdPartyDetails1: // value for 'thirdPartyDetails1'
 *      thirdPartyDetails2: // value for 'thirdPartyDetails2'
 *      thirdPartyDetails3: // value for 'thirdPartyDetails3'
 *      thirdPartyDetails4: // value for 'thirdPartyDetails4'
 *      hasVolunteerAccidentPolicy: // value for 'hasVolunteerAccidentPolicy'
 *   },
 * });
 */
export function useUpdateBusinessAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessAttributesMutation, UpdateBusinessAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessAttributesMutation, UpdateBusinessAttributesMutationVariables>(UpdateBusinessAttributesDocument, options);
      }
export type UpdateBusinessAttributesMutationHookResult = ReturnType<typeof useUpdateBusinessAttributesMutation>;
export type UpdateBusinessAttributesMutationResult = Apollo.MutationResult<UpdateBusinessAttributesMutation>;
export type UpdateBusinessAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessAttributesMutation, UpdateBusinessAttributesMutationVariables>;
export const GetBusinessDetailsDocument = gql`
    query GetBusinessDetails($uuid: ID!) {
  prospect(uuid: $uuid) {
    workersCompApplication: applications(applicationFilter: {type: WORKERS_COMP}) {
      step
      uuid
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    healthInsuranceApplication: applications(
      applicationFilter: {type: HEALTH_INSURANCE}
    ) {
      step
      uuid
    }
    healthInsuranceUpsellApplication: applications(
      applicationFilter: {type: HEALTH_INSURANCE_UPSELL}
    ) {
      step
      uuid
    }
    companyName
    dba
    ein
    website
    yearFounded
    companyInformation {
      yearsInBusiness
      hoursOfOperation
      industry
      industryOther
      industryNaics4
      industryNaics6
      ownerHalfStakeOther
      employeesWorkOtherStakes
      otherStakesDescription
      entityType
      isNonProfit
    }
    relatedEntities {
      uuid
      legalName
      ein
      dba
      description
      isDependent
      sharesLocation
      hasW2Employees
      hasOverlappingEmployees
    }
  }
}
    `;

/**
 * __useGetBusinessDetailsQuery__
 *
 * To run a query within a React component, call `useGetBusinessDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessDetailsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetBusinessDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessDetailsQuery, GetBusinessDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessDetailsQuery, GetBusinessDetailsQueryVariables>(GetBusinessDetailsDocument, options);
      }
export function useGetBusinessDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessDetailsQuery, GetBusinessDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessDetailsQuery, GetBusinessDetailsQueryVariables>(GetBusinessDetailsDocument, options);
        }
export type GetBusinessDetailsQueryHookResult = ReturnType<typeof useGetBusinessDetailsQuery>;
export type GetBusinessDetailsLazyQueryHookResult = ReturnType<typeof useGetBusinessDetailsLazyQuery>;
export type GetBusinessDetailsQueryResult = Apollo.QueryResult<GetBusinessDetailsQuery, GetBusinessDetailsQueryVariables>;
export const UpdateBaseProspectDocument = gql`
    mutation UpdateBaseProspect($uuid: ID!, $companyName: String, $dba: String, $ein: String, $website: [String!], $yearFounded: Int) {
  updateBaseProspect(
    input: {uuid: $uuid, companyName: $companyName, dba: $dba, ein: $ein, website: $website, yearFounded: $yearFounded}
  ) {
    uuid
  }
}
    `;
export type UpdateBaseProspectMutationFn = Apollo.MutationFunction<UpdateBaseProspectMutation, UpdateBaseProspectMutationVariables>;

/**
 * __useUpdateBaseProspectMutation__
 *
 * To run a mutation, you first call `useUpdateBaseProspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaseProspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaseProspectMutation, { data, loading, error }] = useUpdateBaseProspectMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      companyName: // value for 'companyName'
 *      dba: // value for 'dba'
 *      ein: // value for 'ein'
 *      website: // value for 'website'
 *      yearFounded: // value for 'yearFounded'
 *   },
 * });
 */
export function useUpdateBaseProspectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaseProspectMutation, UpdateBaseProspectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaseProspectMutation, UpdateBaseProspectMutationVariables>(UpdateBaseProspectDocument, options);
      }
export type UpdateBaseProspectMutationHookResult = ReturnType<typeof useUpdateBaseProspectMutation>;
export type UpdateBaseProspectMutationResult = Apollo.MutationResult<UpdateBaseProspectMutation>;
export type UpdateBaseProspectMutationOptions = Apollo.BaseMutationOptions<UpdateBaseProspectMutation, UpdateBaseProspectMutationVariables>;
export const UpdateProspectCompanyInfoDocument = gql`
    mutation UpdateProspectCompanyInfo($uuid: ID!, $hoursOfOperation: String, $yearsInBusiness: Int, $entityType: String, $isNonProfit: Boolean, $ownerHalfStakeOther: Boolean, $employeesWorkOtherStakes: Boolean, $otherStakesDescription: String, $industry: String, $industryOther: String, $industryNaics4: String, $industryNaics6: String) {
  updateProspectCompanyInfo(
    input: {uuid: $uuid, companyInfo: {hoursOfOperation: $hoursOfOperation, yearsInBusiness: $yearsInBusiness, entityType: $entityType, isNonProfit: $isNonProfit, industry: $industry, industryOther: $industryOther, industryNaics4: $industryNaics4, industryNaics6: $industryNaics6, ownerHalfStakeOther: $ownerHalfStakeOther, employeesWorkOtherStakes: $employeesWorkOtherStakes, otherStakesDescription: $otherStakesDescription}}
  ) {
    uuid
  }
}
    `;
export type UpdateProspectCompanyInfoMutationFn = Apollo.MutationFunction<UpdateProspectCompanyInfoMutation, UpdateProspectCompanyInfoMutationVariables>;

/**
 * __useUpdateProspectCompanyInfoMutation__
 *
 * To run a mutation, you first call `useUpdateProspectCompanyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProspectCompanyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProspectCompanyInfoMutation, { data, loading, error }] = useUpdateProspectCompanyInfoMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      hoursOfOperation: // value for 'hoursOfOperation'
 *      yearsInBusiness: // value for 'yearsInBusiness'
 *      entityType: // value for 'entityType'
 *      isNonProfit: // value for 'isNonProfit'
 *      ownerHalfStakeOther: // value for 'ownerHalfStakeOther'
 *      employeesWorkOtherStakes: // value for 'employeesWorkOtherStakes'
 *      otherStakesDescription: // value for 'otherStakesDescription'
 *      industry: // value for 'industry'
 *      industryOther: // value for 'industryOther'
 *      industryNaics4: // value for 'industryNaics4'
 *      industryNaics6: // value for 'industryNaics6'
 *   },
 * });
 */
export function useUpdateProspectCompanyInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProspectCompanyInfoMutation, UpdateProspectCompanyInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProspectCompanyInfoMutation, UpdateProspectCompanyInfoMutationVariables>(UpdateProspectCompanyInfoDocument, options);
      }
export type UpdateProspectCompanyInfoMutationHookResult = ReturnType<typeof useUpdateProspectCompanyInfoMutation>;
export type UpdateProspectCompanyInfoMutationResult = Apollo.MutationResult<UpdateProspectCompanyInfoMutation>;
export type UpdateProspectCompanyInfoMutationOptions = Apollo.BaseMutationOptions<UpdateProspectCompanyInfoMutation, UpdateProspectCompanyInfoMutationVariables>;
export const UpdateRelatedEntitiesDocument = gql`
    mutation UpdateRelatedEntities($uuid: ID!, $relatedEntities: [RelatedEntityInput!]!) {
  updateRelatedEntities(
    input: {prospectUuid: $uuid, relatedEntities: $relatedEntities}
  ) {
    relatedEntities {
      uuid
      legalName
      ein
      dba
      hasW2Employees
      hasOverlappingEmployees
      isDependent
    }
  }
}
    `;
export type UpdateRelatedEntitiesMutationFn = Apollo.MutationFunction<UpdateRelatedEntitiesMutation, UpdateRelatedEntitiesMutationVariables>;

/**
 * __useUpdateRelatedEntitiesMutation__
 *
 * To run a mutation, you first call `useUpdateRelatedEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRelatedEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRelatedEntitiesMutation, { data, loading, error }] = useUpdateRelatedEntitiesMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      relatedEntities: // value for 'relatedEntities'
 *   },
 * });
 */
export function useUpdateRelatedEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRelatedEntitiesMutation, UpdateRelatedEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRelatedEntitiesMutation, UpdateRelatedEntitiesMutationVariables>(UpdateRelatedEntitiesDocument, options);
      }
export type UpdateRelatedEntitiesMutationHookResult = ReturnType<typeof useUpdateRelatedEntitiesMutation>;
export type UpdateRelatedEntitiesMutationResult = Apollo.MutationResult<UpdateRelatedEntitiesMutation>;
export type UpdateRelatedEntitiesMutationOptions = Apollo.BaseMutationOptions<UpdateRelatedEntitiesMutation, UpdateRelatedEntitiesMutationVariables>;
export const AddBussinessAddressDocument = gql`
    mutation AddBussinessAddress($uuid: ID!, $address1: String!, $address2: String, $city: String!, $state: String!, $zip: String!, $locationName: String, $isHq: Boolean, $subdivision: String) {
  createOfficeLocation(
    input: {prospectId: $uuid, address1: $address1, address2: $address2, city: $city, state: $state, zip: $zip, locationName: $locationName, isHq: $isHq, subdivision: $subdivision}
  ) {
    uuid
    autoValidated
    suggestedAddress {
      address1
      address2
      city
      state
      zip
    }
  }
}
    `;
export type AddBussinessAddressMutationFn = Apollo.MutationFunction<AddBussinessAddressMutation, AddBussinessAddressMutationVariables>;

/**
 * __useAddBussinessAddressMutation__
 *
 * To run a mutation, you first call `useAddBussinessAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBussinessAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBussinessAddressMutation, { data, loading, error }] = useAddBussinessAddressMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      locationName: // value for 'locationName'
 *      isHq: // value for 'isHq'
 *      subdivision: // value for 'subdivision'
 *   },
 * });
 */
export function useAddBussinessAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddBussinessAddressMutation, AddBussinessAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBussinessAddressMutation, AddBussinessAddressMutationVariables>(AddBussinessAddressDocument, options);
      }
export type AddBussinessAddressMutationHookResult = ReturnType<typeof useAddBussinessAddressMutation>;
export type AddBussinessAddressMutationResult = Apollo.MutationResult<AddBussinessAddressMutation>;
export type AddBussinessAddressMutationOptions = Apollo.BaseMutationOptions<AddBussinessAddressMutation, AddBussinessAddressMutationVariables>;
export const DeleteBussinessAddressDocument = gql`
    mutation DeleteBussinessAddress($uuid: ID!) {
  deleteOfficeLocation(input: {uuid: $uuid}) {
    uuid
  }
}
    `;
export type DeleteBussinessAddressMutationFn = Apollo.MutationFunction<DeleteBussinessAddressMutation, DeleteBussinessAddressMutationVariables>;

/**
 * __useDeleteBussinessAddressMutation__
 *
 * To run a mutation, you first call `useDeleteBussinessAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBussinessAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBussinessAddressMutation, { data, loading, error }] = useDeleteBussinessAddressMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteBussinessAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBussinessAddressMutation, DeleteBussinessAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBussinessAddressMutation, DeleteBussinessAddressMutationVariables>(DeleteBussinessAddressDocument, options);
      }
export type DeleteBussinessAddressMutationHookResult = ReturnType<typeof useDeleteBussinessAddressMutation>;
export type DeleteBussinessAddressMutationResult = Apollo.MutationResult<DeleteBussinessAddressMutation>;
export type DeleteBussinessAddressMutationOptions = Apollo.BaseMutationOptions<DeleteBussinessAddressMutation, DeleteBussinessAddressMutationVariables>;
export const GetBusinessAddressDocument = gql`
    query GetBusinessAddress($uuid: ID!) {
  prospect(uuid: $uuid) {
    applications(applicationFilter: {type: WORKERS_COMP}) {
      uuid
      createdAt
    }
    officeLocations {
      address1
      address2
      city
      locationName
      state
      zip
      autoValidated
      uuid
      isHq
      subdivision
    }
    employeeCensuses {
      officeLocationId
      isCompanyOwner
      isCompanyEmployee
      firstName
    }
  }
}
    `;

/**
 * __useGetBusinessAddressQuery__
 *
 * To run a query within a React component, call `useGetBusinessAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAddressQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetBusinessAddressQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessAddressQuery, GetBusinessAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessAddressQuery, GetBusinessAddressQueryVariables>(GetBusinessAddressDocument, options);
      }
export function useGetBusinessAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessAddressQuery, GetBusinessAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessAddressQuery, GetBusinessAddressQueryVariables>(GetBusinessAddressDocument, options);
        }
export type GetBusinessAddressQueryHookResult = ReturnType<typeof useGetBusinessAddressQuery>;
export type GetBusinessAddressLazyQueryHookResult = ReturnType<typeof useGetBusinessAddressLazyQuery>;
export type GetBusinessAddressQueryResult = Apollo.QueryResult<GetBusinessAddressQuery, GetBusinessAddressQueryVariables>;
export const UpdateBussinessAddressDocument = gql`
    mutation UpdateBussinessAddress($uuid: ID!, $address1: String!, $address2: String, $city: String!, $state: String!, $zip: String!, $locationName: String, $isHq: Boolean, $subdivision: String) {
  updateOfficeLocation(
    input: {uuid: $uuid, address1: $address1, address2: $address2, city: $city, state: $state, zip: $zip, locationName: $locationName, isHq: $isHq, subdivision: $subdivision}
  ) {
    uuid
    autoValidated
    suggestedAddress {
      address1
      address2
      city
      state
      zip
    }
  }
}
    `;
export type UpdateBussinessAddressMutationFn = Apollo.MutationFunction<UpdateBussinessAddressMutation, UpdateBussinessAddressMutationVariables>;

/**
 * __useUpdateBussinessAddressMutation__
 *
 * To run a mutation, you first call `useUpdateBussinessAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBussinessAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBussinessAddressMutation, { data, loading, error }] = useUpdateBussinessAddressMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      locationName: // value for 'locationName'
 *      isHq: // value for 'isHq'
 *      subdivision: // value for 'subdivision'
 *   },
 * });
 */
export function useUpdateBussinessAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBussinessAddressMutation, UpdateBussinessAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBussinessAddressMutation, UpdateBussinessAddressMutationVariables>(UpdateBussinessAddressDocument, options);
      }
export type UpdateBussinessAddressMutationHookResult = ReturnType<typeof useUpdateBussinessAddressMutation>;
export type UpdateBussinessAddressMutationResult = Apollo.MutationResult<UpdateBussinessAddressMutation>;
export type UpdateBussinessAddressMutationOptions = Apollo.BaseMutationOptions<UpdateBussinessAddressMutation, UpdateBussinessAddressMutationVariables>;
export const GetBusinessDescriptionDocument = gql`
    query GetBusinessDescription($uuid: ID!) {
  prospect(uuid: $uuid) {
    applications(applicationFilter: {type: WORKERS_COMP}) {
      uuid
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    companyInformation {
      businessDescription
      dailyOperationsOfEmployees
      hasUnionWorkers
    }
    dba
    ein
    companyName
    website
    yearFounded
  }
}
    `;

/**
 * __useGetBusinessDescriptionQuery__
 *
 * To run a query within a React component, call `useGetBusinessDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessDescriptionQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetBusinessDescriptionQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessDescriptionQuery, GetBusinessDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessDescriptionQuery, GetBusinessDescriptionQueryVariables>(GetBusinessDescriptionDocument, options);
      }
export function useGetBusinessDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessDescriptionQuery, GetBusinessDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessDescriptionQuery, GetBusinessDescriptionQueryVariables>(GetBusinessDescriptionDocument, options);
        }
export type GetBusinessDescriptionQueryHookResult = ReturnType<typeof useGetBusinessDescriptionQuery>;
export type GetBusinessDescriptionLazyQueryHookResult = ReturnType<typeof useGetBusinessDescriptionLazyQuery>;
export type GetBusinessDescriptionQueryResult = Apollo.QueryResult<GetBusinessDescriptionQuery, GetBusinessDescriptionQueryVariables>;
export const UpdateBusinessDescriptionDocument = gql`
    mutation UpdateBusinessDescription($uuid: ID!, $businessDescription: String, $dailyOperationsOfEmployees: String, $hasUnionWorkers: Boolean) {
  updateProspectCompanyInfo(
    input: {uuid: $uuid, companyInfo: {businessDescription: $businessDescription, dailyOperationsOfEmployees: $dailyOperationsOfEmployees, hasUnionWorkers: $hasUnionWorkers}}
  ) {
    uuid
  }
}
    `;
export type UpdateBusinessDescriptionMutationFn = Apollo.MutationFunction<UpdateBusinessDescriptionMutation, UpdateBusinessDescriptionMutationVariables>;

/**
 * __useUpdateBusinessDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessDescriptionMutation, { data, loading, error }] = useUpdateBusinessDescriptionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      businessDescription: // value for 'businessDescription'
 *      dailyOperationsOfEmployees: // value for 'dailyOperationsOfEmployees'
 *      hasUnionWorkers: // value for 'hasUnionWorkers'
 *   },
 * });
 */
export function useUpdateBusinessDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessDescriptionMutation, UpdateBusinessDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessDescriptionMutation, UpdateBusinessDescriptionMutationVariables>(UpdateBusinessDescriptionDocument, options);
      }
export type UpdateBusinessDescriptionMutationHookResult = ReturnType<typeof useUpdateBusinessDescriptionMutation>;
export type UpdateBusinessDescriptionMutationResult = Apollo.MutationResult<UpdateBusinessDescriptionMutation>;
export type UpdateBusinessDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessDescriptionMutation, UpdateBusinessDescriptionMutationVariables>;
export const UpdateBusinessWebsiteDocument = gql`
    mutation UpdateBusinessWebsite($uuid: ID!, $website: [String!], $companyName: String, $dba: String, $ein: String, $yearFounded: Int) {
  updateBaseProspect(
    input: {uuid: $uuid, website: $website, companyName: $companyName, dba: $dba, ein: $ein, yearFounded: $yearFounded}
  ) {
    uuid
  }
}
    `;
export type UpdateBusinessWebsiteMutationFn = Apollo.MutationFunction<UpdateBusinessWebsiteMutation, UpdateBusinessWebsiteMutationVariables>;

/**
 * __useUpdateBusinessWebsiteMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessWebsiteMutation, { data, loading, error }] = useUpdateBusinessWebsiteMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      website: // value for 'website'
 *      companyName: // value for 'companyName'
 *      dba: // value for 'dba'
 *      ein: // value for 'ein'
 *      yearFounded: // value for 'yearFounded'
 *   },
 * });
 */
export function useUpdateBusinessWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessWebsiteMutation, UpdateBusinessWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessWebsiteMutation, UpdateBusinessWebsiteMutationVariables>(UpdateBusinessWebsiteDocument, options);
      }
export type UpdateBusinessWebsiteMutationHookResult = ReturnType<typeof useUpdateBusinessWebsiteMutation>;
export type UpdateBusinessWebsiteMutationResult = Apollo.MutationResult<UpdateBusinessWebsiteMutation>;
export type UpdateBusinessWebsiteMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessWebsiteMutation, UpdateBusinessWebsiteMutationVariables>;
export const AddDocumentDocument = gql`
    mutation AddDocument($applicationId: ID!, $applicationField: String!, $fileSize: Int, $path: String!) {
  createDocument(
    input: {applicationId: $applicationId, applicationField: $applicationField, fileSize: $fileSize, path: $path}
  ) {
    uuid
  }
}
    `;
export type AddDocumentMutationFn = Apollo.MutationFunction<AddDocumentMutation, AddDocumentMutationVariables>;

/**
 * __useAddDocumentMutation__
 *
 * To run a mutation, you first call `useAddDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentMutation, { data, loading, error }] = useAddDocumentMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      applicationField: // value for 'applicationField'
 *      fileSize: // value for 'fileSize'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAddDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddDocumentMutation, AddDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDocumentMutation, AddDocumentMutationVariables>(AddDocumentDocument, options);
      }
export type AddDocumentMutationHookResult = ReturnType<typeof useAddDocumentMutation>;
export type AddDocumentMutationResult = Apollo.MutationResult<AddDocumentMutation>;
export type AddDocumentMutationOptions = Apollo.BaseMutationOptions<AddDocumentMutation, AddDocumentMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($uuid: ID!) {
  deleteDocument(input: {uuid: $uuid}) {
    uuid
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const GetDocumentDocument = gql`
    query GetDocument($uuid: ID!) {
  prospect(uuid: $uuid) {
    applications(applicationFilter: {type: WORKERS_COMP}) {
      uuid
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    companyInformation {
      noLossRunsReportOtherReason
      noLossRunsReportReason
    }
  }
}
    `;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
      }
export function useGetDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentQueryResult = Apollo.QueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export const UpdateNoLossRunsReportReasonDocument = gql`
    mutation UpdateNoLossRunsReportReason($prospectUuid: ID!, $noLossRunsReportOtherReason: String, $noLossRunsReportReason: String) {
  updateNoLossRunsReportReason(
    input: {prospectUuid: $prospectUuid, noLossRunsReportOtherReason: $noLossRunsReportOtherReason, noLossRunsReportReason: $noLossRunsReportReason}
  ) {
    success
  }
}
    `;
export type UpdateNoLossRunsReportReasonMutationFn = Apollo.MutationFunction<UpdateNoLossRunsReportReasonMutation, UpdateNoLossRunsReportReasonMutationVariables>;

/**
 * __useUpdateNoLossRunsReportReasonMutation__
 *
 * To run a mutation, you first call `useUpdateNoLossRunsReportReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoLossRunsReportReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoLossRunsReportReasonMutation, { data, loading, error }] = useUpdateNoLossRunsReportReasonMutation({
 *   variables: {
 *      prospectUuid: // value for 'prospectUuid'
 *      noLossRunsReportOtherReason: // value for 'noLossRunsReportOtherReason'
 *      noLossRunsReportReason: // value for 'noLossRunsReportReason'
 *   },
 * });
 */
export function useUpdateNoLossRunsReportReasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoLossRunsReportReasonMutation, UpdateNoLossRunsReportReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoLossRunsReportReasonMutation, UpdateNoLossRunsReportReasonMutationVariables>(UpdateNoLossRunsReportReasonDocument, options);
      }
export type UpdateNoLossRunsReportReasonMutationHookResult = ReturnType<typeof useUpdateNoLossRunsReportReasonMutation>;
export type UpdateNoLossRunsReportReasonMutationResult = Apollo.MutationResult<UpdateNoLossRunsReportReasonMutation>;
export type UpdateNoLossRunsReportReasonMutationOptions = Apollo.BaseMutationOptions<UpdateNoLossRunsReportReasonMutation, UpdateNoLossRunsReportReasonMutationVariables>;
export const GetEpliDocument = gql`
    query GetEPLI($uuid: ID!) {
  prospect(uuid: $uuid) {
    applications(applicationFilter: {type: WORKERS_COMP}) {
      uuid
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    companyInformation {
      epli {
        hasPolicy
        overTwentyFiveEe
        receivedEpliAllegations
        beenSuedFormerEmp
        offeredSeverancePackages
        claimDetails
        noEpliLossRunsReportOtherReason
        noEpliLossRunsReportReason
      }
    }
  }
}
    `;

/**
 * __useGetEpliQuery__
 *
 * To run a query within a React component, call `useGetEpliQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpliQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetEpliQuery(baseOptions: Apollo.QueryHookOptions<GetEpliQuery, GetEpliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpliQuery, GetEpliQueryVariables>(GetEpliDocument, options);
      }
export function useGetEpliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpliQuery, GetEpliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpliQuery, GetEpliQueryVariables>(GetEpliDocument, options);
        }
export type GetEpliQueryHookResult = ReturnType<typeof useGetEpliQuery>;
export type GetEpliLazyQueryHookResult = ReturnType<typeof useGetEpliLazyQuery>;
export type GetEpliQueryResult = Apollo.QueryResult<GetEpliQuery, GetEpliQueryVariables>;
export const UpdateEpliDocument = gql`
    mutation UpdateEPLI($uuid: ID!, $hasPolicy: Boolean, $overTwentyFiveEe: Boolean, $receivedEpliAllegations: Boolean, $beenSuedFormerEmp: Boolean, $offeredSeverancePackages: Boolean, $claimDetails: String, $noEpliLossRunsReportOtherReason: String, $noEpliLossRunsReportReason: String) {
  updateProspectEpli(
    input: {uuid: $uuid, epli: {hasPolicy: $hasPolicy, overTwentyFiveEe: $overTwentyFiveEe, receivedEpliAllegations: $receivedEpliAllegations, beenSuedFormerEmp: $beenSuedFormerEmp, offeredSeverancePackages: $offeredSeverancePackages, claimDetails: $claimDetails, noEpliLossRunsReportOtherReason: $noEpliLossRunsReportOtherReason, noEpliLossRunsReportReason: $noEpliLossRunsReportReason}}
  ) {
    uuid
  }
}
    `;
export type UpdateEpliMutationFn = Apollo.MutationFunction<UpdateEpliMutation, UpdateEpliMutationVariables>;

/**
 * __useUpdateEpliMutation__
 *
 * To run a mutation, you first call `useUpdateEpliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpliMutation, { data, loading, error }] = useUpdateEpliMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      hasPolicy: // value for 'hasPolicy'
 *      overTwentyFiveEe: // value for 'overTwentyFiveEe'
 *      receivedEpliAllegations: // value for 'receivedEpliAllegations'
 *      beenSuedFormerEmp: // value for 'beenSuedFormerEmp'
 *      offeredSeverancePackages: // value for 'offeredSeverancePackages'
 *      claimDetails: // value for 'claimDetails'
 *      noEpliLossRunsReportOtherReason: // value for 'noEpliLossRunsReportOtherReason'
 *      noEpliLossRunsReportReason: // value for 'noEpliLossRunsReportReason'
 *   },
 * });
 */
export function useUpdateEpliMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEpliMutation, UpdateEpliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEpliMutation, UpdateEpliMutationVariables>(UpdateEpliDocument, options);
      }
export type UpdateEpliMutationHookResult = ReturnType<typeof useUpdateEpliMutation>;
export type UpdateEpliMutationResult = Apollo.MutationResult<UpdateEpliMutation>;
export type UpdateEpliMutationOptions = Apollo.BaseMutationOptions<UpdateEpliMutation, UpdateEpliMutationVariables>;
export const GetEmployeeAttributesDocument = gql`
    query GetEmployeeAttributes($uuid: ID!) {
  prospect(uuid: $uuid) {
    employeeCensuses {
      uuid
      isCompanyOwner
      isCompanyEmployee
      firstName
      middleName
      lastName
      email
    }
    companyInformation {
      bizActivities {
        deliveries
        employeesWhoMakeDeliveries {
          employeeId
          deliveryTransportationType
          deliveryDistance
          deliveryFrequency
        }
      }
      hasEmployees {
        travel
        employeesWhoTravel {
          employeeId
          travelPurpose
          travelInternationally
          travelLocation
          travelFrequency
        }
        employeesWhoUseTools {
          employeeId
          hardwareNames
        }
        underageOrSeniorEmployees {
          dateOfBirth
          employeeId
          jobTitle
        }
        hardware
        employeesPhysicalLabor
        hasContractors
        employmentDuration
        numberContractors
        percentContractors
        contractorWorkType
        contractorsHaveWorkComp
        contractorsHaveWorkersCompCois
        numberTemp
        boatsBridges
        employeesWorkUnderground
        employeesWorkOnLadders
        employeePerformHeavyLifting
        physicalDisability
        underageOrSenior
        employeesWhoRequirePhysicalLabor {
          employeeId
          percentPhysicalLabor
        }
        employeesWhoUseBoatsBridges
        employeesWhoWorkUnderground {
          employeeId
          undergroundDescription
        }
        employeesWhoWorkOnLadders {
          employeeId
          laddersDescription
        }
        employeesWhoPerformHeavyLifting {
          employeeId
          maximumWeightLifted
        }
        employeesWhoHavePhysicalDisabilities
      }
    }
  }
}
    `;

/**
 * __useGetEmployeeAttributesQuery__
 *
 * To run a query within a React component, call `useGetEmployeeAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeAttributesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetEmployeeAttributesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeAttributesQuery, GetEmployeeAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeAttributesQuery, GetEmployeeAttributesQueryVariables>(GetEmployeeAttributesDocument, options);
      }
export function useGetEmployeeAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeAttributesQuery, GetEmployeeAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeAttributesQuery, GetEmployeeAttributesQueryVariables>(GetEmployeeAttributesDocument, options);
        }
export type GetEmployeeAttributesQueryHookResult = ReturnType<typeof useGetEmployeeAttributesQuery>;
export type GetEmployeeAttributesLazyQueryHookResult = ReturnType<typeof useGetEmployeeAttributesLazyQuery>;
export type GetEmployeeAttributesQueryResult = Apollo.QueryResult<GetEmployeeAttributesQuery, GetEmployeeAttributesQueryVariables>;
export const UpdateEmployeeAttributesDocument = gql`
    mutation UpdateEmployeeAttributes($uuid: ID!, $employeesWhoTravel: [EmployeesWhoTravelInput!], $employeesWhoUseTools: [EmployeesWhoUseToolsInput!], $underageOrSeniorEmployees: [UnderageOrSeniorEmployeesInput!], $travel: Boolean, $hardware: Boolean, $employeesPhysicalLabor: Boolean, $hasContractors: Boolean, $employmentDuration: String, $numberContractors: String, $percentContractors: String, $contractorWorkType: String, $contractorsHaveWorkComp: Boolean, $contractorsHaveWorkersCompCOIS: Boolean, $numberTemp: String, $boatsBridges: Boolean, $employeesWorkUnderground: Boolean, $employeesWorkOnLadders: Boolean, $employeePerformHeavyLifting: Boolean, $physicalDisability: Boolean, $underageOrSenior: Boolean, $employeesWhoRequirePhysicalLabor: [EmployeesWhoRequirePhysicalLaborInput!], $employeesWhoUseBoatsBridges: [ID!], $employeesWhoWorkUnderground: [EmployeesWhoWorkUndergroundInput!], $employeesWhoWorkOnLadders: [EmployeesWhoWorkOnLaddersInput!], $employeesWhoPerformHeavyLifting: [EmployeesWhoPerformHeavyLiftingInput!], $employeesWhoHavePhysicalDisabilities: [ID!]) {
  updateProspectEmployeeFlags(
    input: {uuid: $uuid, employeeFlags: {travel: $travel, employeesWhoTravel: $employeesWhoTravel, employeesWhoUseTools: $employeesWhoUseTools, underageOrSeniorEmployees: $underageOrSeniorEmployees, hardware: $hardware, employeesPhysicalLabor: $employeesPhysicalLabor, hasContractors: $hasContractors, employmentDuration: $employmentDuration, numberContractors: $numberContractors, percentContractors: $percentContractors, contractorWorkType: $contractorWorkType, contractorsHaveWorkComp: $contractorsHaveWorkComp, contractorsHaveWorkersCompCOIS: $contractorsHaveWorkersCompCOIS, numberTemp: $numberTemp, boatsBridges: $boatsBridges, employeesWorkUnderground: $employeesWorkUnderground, employeesWorkOnLadders: $employeesWorkOnLadders, employeePerformHeavyLifting: $employeePerformHeavyLifting, physicalDisability: $physicalDisability, underageOrSenior: $underageOrSenior, employeesWhoRequirePhysicalLabor: $employeesWhoRequirePhysicalLabor, employeesWhoUseBoatsBridges: $employeesWhoUseBoatsBridges, employeesWhoWorkUnderground: $employeesWhoWorkUnderground, employeesWhoWorkOnLadders: $employeesWhoWorkOnLadders, employeesWhoPerformHeavyLifting: $employeesWhoPerformHeavyLifting, employeesWhoHavePhysicalDisabilities: $employeesWhoHavePhysicalDisabilities}}
  ) {
    uuid
  }
}
    `;
export type UpdateEmployeeAttributesMutationFn = Apollo.MutationFunction<UpdateEmployeeAttributesMutation, UpdateEmployeeAttributesMutationVariables>;

/**
 * __useUpdateEmployeeAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeAttributesMutation, { data, loading, error }] = useUpdateEmployeeAttributesMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      employeesWhoTravel: // value for 'employeesWhoTravel'
 *      employeesWhoUseTools: // value for 'employeesWhoUseTools'
 *      underageOrSeniorEmployees: // value for 'underageOrSeniorEmployees'
 *      travel: // value for 'travel'
 *      hardware: // value for 'hardware'
 *      employeesPhysicalLabor: // value for 'employeesPhysicalLabor'
 *      hasContractors: // value for 'hasContractors'
 *      employmentDuration: // value for 'employmentDuration'
 *      numberContractors: // value for 'numberContractors'
 *      percentContractors: // value for 'percentContractors'
 *      contractorWorkType: // value for 'contractorWorkType'
 *      contractorsHaveWorkComp: // value for 'contractorsHaveWorkComp'
 *      contractorsHaveWorkersCompCOIS: // value for 'contractorsHaveWorkersCompCOIS'
 *      numberTemp: // value for 'numberTemp'
 *      boatsBridges: // value for 'boatsBridges'
 *      employeesWorkUnderground: // value for 'employeesWorkUnderground'
 *      employeesWorkOnLadders: // value for 'employeesWorkOnLadders'
 *      employeePerformHeavyLifting: // value for 'employeePerformHeavyLifting'
 *      physicalDisability: // value for 'physicalDisability'
 *      underageOrSenior: // value for 'underageOrSenior'
 *      employeesWhoRequirePhysicalLabor: // value for 'employeesWhoRequirePhysicalLabor'
 *      employeesWhoUseBoatsBridges: // value for 'employeesWhoUseBoatsBridges'
 *      employeesWhoWorkUnderground: // value for 'employeesWhoWorkUnderground'
 *      employeesWhoWorkOnLadders: // value for 'employeesWhoWorkOnLadders'
 *      employeesWhoPerformHeavyLifting: // value for 'employeesWhoPerformHeavyLifting'
 *      employeesWhoHavePhysicalDisabilities: // value for 'employeesWhoHavePhysicalDisabilities'
 *   },
 * });
 */
export function useUpdateEmployeeAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeAttributesMutation, UpdateEmployeeAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeAttributesMutation, UpdateEmployeeAttributesMutationVariables>(UpdateEmployeeAttributesDocument, options);
      }
export type UpdateEmployeeAttributesMutationHookResult = ReturnType<typeof useUpdateEmployeeAttributesMutation>;
export type UpdateEmployeeAttributesMutationResult = Apollo.MutationResult<UpdateEmployeeAttributesMutation>;
export type UpdateEmployeeAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeAttributesMutation, UpdateEmployeeAttributesMutationVariables>;
export const UpdateEmployeeDeliveryAttributeDocument = gql`
    mutation UpdateEmployeeDeliveryAttribute($uuid: ID!, $deliveries: Boolean, $employeesWhoMakeDeliveries: [EmployeesWhoMakeDeliveriesInput!]) {
  updateProspectBizActivities(
    input: {uuid: $uuid, bizActivities: {deliveries: $deliveries, employeesWhoMakeDeliveries: $employeesWhoMakeDeliveries}}
  ) {
    uuid
  }
}
    `;
export type UpdateEmployeeDeliveryAttributeMutationFn = Apollo.MutationFunction<UpdateEmployeeDeliveryAttributeMutation, UpdateEmployeeDeliveryAttributeMutationVariables>;

/**
 * __useUpdateEmployeeDeliveryAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeDeliveryAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeDeliveryAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeDeliveryAttributeMutation, { data, loading, error }] = useUpdateEmployeeDeliveryAttributeMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      deliveries: // value for 'deliveries'
 *      employeesWhoMakeDeliveries: // value for 'employeesWhoMakeDeliveries'
 *   },
 * });
 */
export function useUpdateEmployeeDeliveryAttributeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeDeliveryAttributeMutation, UpdateEmployeeDeliveryAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeDeliveryAttributeMutation, UpdateEmployeeDeliveryAttributeMutationVariables>(UpdateEmployeeDeliveryAttributeDocument, options);
      }
export type UpdateEmployeeDeliveryAttributeMutationHookResult = ReturnType<typeof useUpdateEmployeeDeliveryAttributeMutation>;
export type UpdateEmployeeDeliveryAttributeMutationResult = Apollo.MutationResult<UpdateEmployeeDeliveryAttributeMutation>;
export type UpdateEmployeeDeliveryAttributeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeDeliveryAttributeMutation, UpdateEmployeeDeliveryAttributeMutationVariables>;
export const AddOwnerAndEmployeeCensusDocument = gql`
    mutation AddOwnerAndEmployeeCensus($prospectId: ID!, $firstName: String!, $middleName: String, $lastName: String!, $title: String, $roleDescription: String, $ownerStake: Int, $isPaid: String, $salary: Float, $isCompanyOwner: Boolean, $isCompanyEmployee: Boolean, $salaryType: String, $hourlyRate: Float, $hoursWeekly: Float, $email: String!, $officeLocationId: ID, $exemptionStatus: EmployeeExemptionStatusEnum, $isRemote: Boolean!, $remoteAddress: AddressInput, $employeeType: String, $department: String, $workersCompensationClassification: String, $adminAccess: Boolean, $source: EmployeeCensusSourceEnum) {
  createEmployeeCensus(
    input: {prospectId: $prospectId, email: $email, firstName: $firstName, middleName: $middleName, lastName: $lastName, isCompanyOwner: $isCompanyOwner, isCompanyEmployee: $isCompanyEmployee, officeLocationId: $officeLocationId, employeeType: $employeeType, source: $source, employeeInformation: {department: $department, roleDescription: $roleDescription, title: $title, salary: $salary, ownerStake: $ownerStake, isPaid: $isPaid, salaryType: $salaryType, hourlyRate: $hourlyRate, hoursWeekly: $hoursWeekly, exemptionStatus: $exemptionStatus, isRemote: $isRemote, remoteAddress: $remoteAddress, adminAccess: $adminAccess, workersCompensationClassification: $workersCompensationClassification}}
  ) {
    uuid
    addressAutoValidated
    suggestedAddress {
      address1
      address2
      city
      state
      zip
    }
  }
}
    `;
export type AddOwnerAndEmployeeCensusMutationFn = Apollo.MutationFunction<AddOwnerAndEmployeeCensusMutation, AddOwnerAndEmployeeCensusMutationVariables>;

/**
 * __useAddOwnerAndEmployeeCensusMutation__
 *
 * To run a mutation, you first call `useAddOwnerAndEmployeeCensusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOwnerAndEmployeeCensusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOwnerAndEmployeeCensusMutation, { data, loading, error }] = useAddOwnerAndEmployeeCensusMutation({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      firstName: // value for 'firstName'
 *      middleName: // value for 'middleName'
 *      lastName: // value for 'lastName'
 *      title: // value for 'title'
 *      roleDescription: // value for 'roleDescription'
 *      ownerStake: // value for 'ownerStake'
 *      isPaid: // value for 'isPaid'
 *      salary: // value for 'salary'
 *      isCompanyOwner: // value for 'isCompanyOwner'
 *      isCompanyEmployee: // value for 'isCompanyEmployee'
 *      salaryType: // value for 'salaryType'
 *      hourlyRate: // value for 'hourlyRate'
 *      hoursWeekly: // value for 'hoursWeekly'
 *      email: // value for 'email'
 *      officeLocationId: // value for 'officeLocationId'
 *      exemptionStatus: // value for 'exemptionStatus'
 *      isRemote: // value for 'isRemote'
 *      remoteAddress: // value for 'remoteAddress'
 *      employeeType: // value for 'employeeType'
 *      department: // value for 'department'
 *      workersCompensationClassification: // value for 'workersCompensationClassification'
 *      adminAccess: // value for 'adminAccess'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAddOwnerAndEmployeeCensusMutation(baseOptions?: Apollo.MutationHookOptions<AddOwnerAndEmployeeCensusMutation, AddOwnerAndEmployeeCensusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOwnerAndEmployeeCensusMutation, AddOwnerAndEmployeeCensusMutationVariables>(AddOwnerAndEmployeeCensusDocument, options);
      }
export type AddOwnerAndEmployeeCensusMutationHookResult = ReturnType<typeof useAddOwnerAndEmployeeCensusMutation>;
export type AddOwnerAndEmployeeCensusMutationResult = Apollo.MutationResult<AddOwnerAndEmployeeCensusMutation>;
export type AddOwnerAndEmployeeCensusMutationOptions = Apollo.BaseMutationOptions<AddOwnerAndEmployeeCensusMutation, AddOwnerAndEmployeeCensusMutationVariables>;
export const DeleteOwnerAndEmployeeCensusDocument = gql`
    mutation DeleteOwnerAndEmployeeCensus($uuid: ID!) {
  deleteEmployeeCensus(input: {uuid: $uuid}) {
    uuid
  }
}
    `;
export type DeleteOwnerAndEmployeeCensusMutationFn = Apollo.MutationFunction<DeleteOwnerAndEmployeeCensusMutation, DeleteOwnerAndEmployeeCensusMutationVariables>;

/**
 * __useDeleteOwnerAndEmployeeCensusMutation__
 *
 * To run a mutation, you first call `useDeleteOwnerAndEmployeeCensusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOwnerAndEmployeeCensusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOwnerAndEmployeeCensusMutation, { data, loading, error }] = useDeleteOwnerAndEmployeeCensusMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteOwnerAndEmployeeCensusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOwnerAndEmployeeCensusMutation, DeleteOwnerAndEmployeeCensusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOwnerAndEmployeeCensusMutation, DeleteOwnerAndEmployeeCensusMutationVariables>(DeleteOwnerAndEmployeeCensusDocument, options);
      }
export type DeleteOwnerAndEmployeeCensusMutationHookResult = ReturnType<typeof useDeleteOwnerAndEmployeeCensusMutation>;
export type DeleteOwnerAndEmployeeCensusMutationResult = Apollo.MutationResult<DeleteOwnerAndEmployeeCensusMutation>;
export type DeleteOwnerAndEmployeeCensusMutationOptions = Apollo.BaseMutationOptions<DeleteOwnerAndEmployeeCensusMutation, DeleteOwnerAndEmployeeCensusMutationVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($uuid: ID!) {
  prospect(uuid: $uuid) {
    companyInformation {
      hasEmployees {
        employeesWhoTravel {
          employeeId
        }
        employeesWhoUseTools {
          employeeId
        }
        underageOrSeniorEmployees {
          employeeId
        }
      }
    }
    employeeCensuses {
      uuid
      officeLocationId
      email
      firstName
      middleName
      lastName
      isCompanyOwner
      isCompanyEmployee
      employeeType
      employeeInformation {
        title
        department
        adminAccess
        salaryType
        salary
        hourlyRate
        hoursWeekly
        workersCompensationClassification
        exemptionStatus
        isRemote
        remoteAddress {
          address1
          address2
          city
          state
          zip
          autoValidated
        }
      }
    }
    officeLocations {
      locationName
      address2
      address1
      city
      state
      zip
      uuid
      isHq
    }
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetOwnerDocument = gql`
    query GetOwner($uuid: ID!) {
  prospect(uuid: $uuid) {
    employeeCensuses {
      uuid
      email
      firstName
      middleName
      lastName
      isCompanyOwner
      isCompanyEmployee
      officeLocationId
      employeeInformation {
        isPaid
        title
        roleDescription
        salaryType
        salary
        hourlyRate
        hoursWeekly
        ownerStake
        exemptionStatus
        isRemote
        remoteAddress {
          address1
          address2
          city
          state
          zip
          autoValidated
        }
      }
    }
    officeLocations {
      locationName
      address1
      address2
      city
      state
      zip
      uuid
      isHq
    }
  }
}
    `;

/**
 * __useGetOwnerQuery__
 *
 * To run a query within a React component, call `useGetOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerQuery, GetOwnerQueryVariables>(GetOwnerDocument, options);
      }
export function useGetOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerQuery, GetOwnerQueryVariables>(GetOwnerDocument, options);
        }
export type GetOwnerQueryHookResult = ReturnType<typeof useGetOwnerQuery>;
export type GetOwnerLazyQueryHookResult = ReturnType<typeof useGetOwnerLazyQuery>;
export type GetOwnerQueryResult = Apollo.QueryResult<GetOwnerQuery, GetOwnerQueryVariables>;
export const UpdateOwnerAndEmployeeCensusDocument = gql`
    mutation UpdateOwnerAndEmployeeCensus($uuid: ID!, $firstName: String!, $middleName: String, $lastName: String!, $title: String, $roleDescription: String, $ownerStake: Int, $isPaid: String, $salary: Float, $isCompanyOwner: Boolean, $isCompanyEmployee: Boolean, $salaryType: String, $hourlyRate: Float, $hoursWeekly: Float, $email: String!, $officeLocationId: ID, $exemptionStatus: EmployeeExemptionStatusEnum, $isRemote: Boolean!, $remoteAddress: AddressInput, $employeeType: String, $department: String, $workersCompensationClassification: String, $adminAccess: Boolean) {
  updateEmployeeCensus(
    input: {uuid: $uuid, email: $email, firstName: $firstName, middleName: $middleName, lastName: $lastName, employeeType: $employeeType, isCompanyOwner: $isCompanyOwner, isCompanyEmployee: $isCompanyEmployee, officeLocationId: $officeLocationId, employeeInformation: {department: $department, roleDescription: $roleDescription, title: $title, salary: $salary, ownerStake: $ownerStake, isPaid: $isPaid, salaryType: $salaryType, hourlyRate: $hourlyRate, hoursWeekly: $hoursWeekly, exemptionStatus: $exemptionStatus, isRemote: $isRemote, remoteAddress: $remoteAddress, workersCompensationClassification: $workersCompensationClassification, adminAccess: $adminAccess}}
  ) {
    uuid
    addressAutoValidated
    suggestedAddress {
      address1
      address2
      city
      state
      zip
    }
  }
}
    `;
export type UpdateOwnerAndEmployeeCensusMutationFn = Apollo.MutationFunction<UpdateOwnerAndEmployeeCensusMutation, UpdateOwnerAndEmployeeCensusMutationVariables>;

/**
 * __useUpdateOwnerAndEmployeeCensusMutation__
 *
 * To run a mutation, you first call `useUpdateOwnerAndEmployeeCensusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnerAndEmployeeCensusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnerAndEmployeeCensusMutation, { data, loading, error }] = useUpdateOwnerAndEmployeeCensusMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      firstName: // value for 'firstName'
 *      middleName: // value for 'middleName'
 *      lastName: // value for 'lastName'
 *      title: // value for 'title'
 *      roleDescription: // value for 'roleDescription'
 *      ownerStake: // value for 'ownerStake'
 *      isPaid: // value for 'isPaid'
 *      salary: // value for 'salary'
 *      isCompanyOwner: // value for 'isCompanyOwner'
 *      isCompanyEmployee: // value for 'isCompanyEmployee'
 *      salaryType: // value for 'salaryType'
 *      hourlyRate: // value for 'hourlyRate'
 *      hoursWeekly: // value for 'hoursWeekly'
 *      email: // value for 'email'
 *      officeLocationId: // value for 'officeLocationId'
 *      exemptionStatus: // value for 'exemptionStatus'
 *      isRemote: // value for 'isRemote'
 *      remoteAddress: // value for 'remoteAddress'
 *      employeeType: // value for 'employeeType'
 *      department: // value for 'department'
 *      workersCompensationClassification: // value for 'workersCompensationClassification'
 *      adminAccess: // value for 'adminAccess'
 *   },
 * });
 */
export function useUpdateOwnerAndEmployeeCensusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnerAndEmployeeCensusMutation, UpdateOwnerAndEmployeeCensusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnerAndEmployeeCensusMutation, UpdateOwnerAndEmployeeCensusMutationVariables>(UpdateOwnerAndEmployeeCensusDocument, options);
      }
export type UpdateOwnerAndEmployeeCensusMutationHookResult = ReturnType<typeof useUpdateOwnerAndEmployeeCensusMutation>;
export type UpdateOwnerAndEmployeeCensusMutationResult = Apollo.MutationResult<UpdateOwnerAndEmployeeCensusMutation>;
export type UpdateOwnerAndEmployeeCensusMutationOptions = Apollo.BaseMutationOptions<UpdateOwnerAndEmployeeCensusMutation, UpdateOwnerAndEmployeeCensusMutationVariables>;
export const GetOwnerAndEmployeeCensusDocument = gql`
    query GetOwnerAndEmployeeCensus($uuid: ID!) {
  prospect(uuid: $uuid) {
    employeeCensuses {
      uuid
      officeLocationId
      email
      firstName
      middleName
      lastName
      isCompanyOwner
      isCompanyEmployee
      employeeType
      employeeInformation {
        isPaid
        title
        roleDescription
        department
        adminAccess
        salaryType
        salary
        hourlyRate
        hoursWeekly
        workersCompensationClassification
        ownerStake
        exemptionStatus
        isRemote
        remoteAddress {
          address1
          address2
          city
          state
          zip
          autoValidated
        }
      }
    }
    officeLocations {
      locationName
      address2
      address1
      city
      state
      zip
      uuid
      isHq
    }
    workersCompApplication: applications(applicationFilter: {type: WORKERS_COMP}) {
      uuid
      status
    }
    healthInsuranceApplication: applications(
      applicationFilter: {type: HEALTH_INSURANCE}
    ) {
      uuid
      status
    }
  }
}
    `;

/**
 * __useGetOwnerAndEmployeeCensusQuery__
 *
 * To run a query within a React component, call `useGetOwnerAndEmployeeCensusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAndEmployeeCensusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerAndEmployeeCensusQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetOwnerAndEmployeeCensusQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerAndEmployeeCensusQuery, GetOwnerAndEmployeeCensusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerAndEmployeeCensusQuery, GetOwnerAndEmployeeCensusQueryVariables>(GetOwnerAndEmployeeCensusDocument, options);
      }
export function useGetOwnerAndEmployeeCensusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerAndEmployeeCensusQuery, GetOwnerAndEmployeeCensusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerAndEmployeeCensusQuery, GetOwnerAndEmployeeCensusQueryVariables>(GetOwnerAndEmployeeCensusDocument, options);
        }
export type GetOwnerAndEmployeeCensusQueryHookResult = ReturnType<typeof useGetOwnerAndEmployeeCensusQuery>;
export type GetOwnerAndEmployeeCensusLazyQueryHookResult = ReturnType<typeof useGetOwnerAndEmployeeCensusLazyQuery>;
export type GetOwnerAndEmployeeCensusQueryResult = Apollo.QueryResult<GetOwnerAndEmployeeCensusQuery, GetOwnerAndEmployeeCensusQueryVariables>;
export const GetProspectDataDocument = gql`
    query GetProspectData($uuid: ID!) {
  prospect(uuid: $uuid) {
    applications(applicationFilter: {type: WORKERS_COMP}) {
      uuid
      createdAt
      documents {
        accessLink
        applicationField
        fileName
        uuid
      }
    }
    website
    uuid
    ein
    companyName
    dba
    yearFounded
    relatedEntities {
      uuid
      legalName
      ein
      dba
      description
      isDependent
      sharesLocation
      hasW2Employees
      hasOverlappingEmployees
    }
    companyInformation {
      industry
      industryOther
      industryNaics4
      industryNaics6
      noLossRunsReportOtherReason
      noLossRunsReportReason
      employeesWorkOtherStakes
      otherStakesDescription
      ownerHalfStakeOther
      dailyOperationsOfEmployees
      entityName
      npoStatus
      entityType
      isNonProfit
      yearsInBusiness
      isRemainingStateInvestors
      hasExistingPolicy
      hasUnionWorkers
      hoursOfOperation
      primaryPhoneNumber
      businessDescription
      epli {
        beenSuedFormerEmp
        claimDetails
        hasPolicy
        noEpliLossRunsReportReason
        noEpliLossRunsReportOtherReason
        offeredSeverancePackages
        overTwentyFiveEe
        receivedEpliAllegations
      }
      bizActivities {
        beenCancelled
        beenDeclined
        deliveries
        employeesWhoMakeDeliveries {
          employeeId
          deliveryDistance
          deliveryFrequency
          deliveryTransportationType
        }
        hasPastDuePremiums
        hasPriorCarriers
        hasHadWorkersCompPolicy
        hasTaxLeinBankrupcy
        hasVolunteers
        hasVolunteerAccidentPolicy
        hasWrittenSafteyProg
        hazardousMats
        numberVolunteers
        offerHealthInsurance
        ownAircraftWatercraft
        policyCancelledReason
        priorCarriers
        requirePhysicals
        sponsorSportsTeams
        thirdPartyDetails1
        thirdPartyDetails2
        thirdPartyDetails3
        thirdPartyDetails4
        thirdPartyDetails5
        use3rdPartyVendors
        volunteerActivities
        volunteerAges
        volunteerTravel
        workersCompDeclinedReason
      }
      hasEmployees {
        travel
        employeesWhoTravel {
          employeeId
          travelPurpose
          travelInternationally
          travelLocation
          travelFrequency
        }
        employeesWhoUseTools {
          employeeId
          hardwareNames
        }
        underageOrSeniorEmployees {
          dateOfBirth
          employeeId
          jobTitle
        }
        employeesWhoRequirePhysicalLabor {
          employeeId
          percentPhysicalLabor
        }
        employeesWhoUseBoatsBridges
        employeesWhoHavePhysicalDisabilities
        hardware
        employeesPhysicalLabor
        hasContractors
        employmentDuration
        numberContractors
        percentContractors
        contractorWorkType
        contractorsHaveWorkComp
        contractorsHaveWorkersCompCois
        numberTemp
        boatsBridges
        employeesWorkUnderground
        employeesWhoWorkUnderground {
          employeeId
          undergroundDescription
        }
        employeesWorkOnLadders
        employeesWhoWorkOnLadders {
          employeeId
          laddersDescription
        }
        employeePerformHeavyLifting
        employeesWhoPerformHeavyLifting {
          employeeId
          maximumWeightLifted
        }
        physicalDisability
        underageOrSenior
      }
    }
    officeLocations {
      address1
      address2
      city
      locationName
      zip
      state
      uuid
      isHq
      subdivision
      autoValidated
    }
    employeeCensuses {
      employeeType
      email
      firstName
      isCompanyOwner
      isCompanyEmployee
      lastName
      middleName
      uuid
      officeLocationId
      employeeType
      employeeInformation {
        adminAccess
        department
        employeesWorkOtherStakes
        hourlyRate
        hoursWeekly
        isPaid
        manager
        ownerStake
        roleDescription
        salary
        salaryType
        title
        workersCompensationClassification
        exemptionStatus
        isRemote
        remoteAddress {
          address1
          address2
          city
          state
          zip
          autoValidated
        }
      }
    }
  }
}
    `;

/**
 * __useGetProspectDataQuery__
 *
 * To run a query within a React component, call `useGetProspectDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectDataQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetProspectDataQuery(baseOptions: Apollo.QueryHookOptions<GetProspectDataQuery, GetProspectDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProspectDataQuery, GetProspectDataQueryVariables>(GetProspectDataDocument, options);
      }
export function useGetProspectDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProspectDataQuery, GetProspectDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProspectDataQuery, GetProspectDataQueryVariables>(GetProspectDataDocument, options);
        }
export type GetProspectDataQueryHookResult = ReturnType<typeof useGetProspectDataQuery>;
export type GetProspectDataLazyQueryHookResult = ReturnType<typeof useGetProspectDataLazyQuery>;
export type GetProspectDataQueryResult = Apollo.QueryResult<GetProspectDataQuery, GetProspectDataQueryVariables>;
export const CreateApplicationDocument = gql`
    mutation createApplication($prospectId: ID!, $prospectCanonicalId: String, $applicationSteps: [String!]) {
  createApplication(
    input: {prospectId: $prospectId, prospectCanonicalId: $prospectCanonicalId, appType: WORKERS_COMP, applicationSteps: $applicationSteps}
  ) {
    uuid
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      prospectCanonicalId: // value for 'prospectCanonicalId'
 *      applicationSteps: // value for 'applicationSteps'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const GetStepDocument = gql`
    query GetStep($uuid: ID!) {
  prospect(uuid: $uuid) {
    applications(applicationFilter: {type: WORKERS_COMP}) {
      step
      flowVersion
      uuid
      status
      createdAt
    }
  }
}
    `;

/**
 * __useGetStepQuery__
 *
 * To run a query within a React component, call `useGetStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStepQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetStepQuery(baseOptions: Apollo.QueryHookOptions<GetStepQuery, GetStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStepQuery, GetStepQueryVariables>(GetStepDocument, options);
      }
export function useGetStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStepQuery, GetStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStepQuery, GetStepQueryVariables>(GetStepDocument, options);
        }
export type GetStepQueryHookResult = ReturnType<typeof useGetStepQuery>;
export type GetStepLazyQueryHookResult = ReturnType<typeof useGetStepLazyQuery>;
export type GetStepQueryResult = Apollo.QueryResult<GetStepQuery, GetStepQueryVariables>;
export const UpdateStepDocument = gql`
    mutation UpdateStep($uuid: ID!, $step: Int!) {
  updateApplicationStep(input: {uuid: $uuid, step: $step}) {
    uuid
  }
}
    `;
export type UpdateStepMutationFn = Apollo.MutationFunction<UpdateStepMutation, UpdateStepMutationVariables>;

/**
 * __useUpdateStepMutation__
 *
 * To run a mutation, you first call `useUpdateStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStepMutation, { data, loading, error }] = useUpdateStepMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      step: // value for 'step'
 *   },
 * });
 */
export function useUpdateStepMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStepMutation, UpdateStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStepMutation, UpdateStepMutationVariables>(UpdateStepDocument, options);
      }
export type UpdateStepMutationHookResult = ReturnType<typeof useUpdateStepMutation>;
export type UpdateStepMutationResult = Apollo.MutationResult<UpdateStepMutation>;
export type UpdateStepMutationOptions = Apollo.BaseMutationOptions<UpdateStepMutation, UpdateStepMutationVariables>;
export const GetProspectDocument = gql`
    query GetProspect($uuid: ID!) {
  prospect(uuid: $uuid) {
    companyName
    dba
    ein
    uuid
  }
}
    `;

/**
 * __useGetProspectQuery__
 *
 * To run a query within a React component, call `useGetProspectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetProspectQuery(baseOptions: Apollo.QueryHookOptions<GetProspectQuery, GetProspectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProspectQuery, GetProspectQueryVariables>(GetProspectDocument, options);
      }
export function useGetProspectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProspectQuery, GetProspectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProspectQuery, GetProspectQueryVariables>(GetProspectDocument, options);
        }
export type GetProspectQueryHookResult = ReturnType<typeof useGetProspectQuery>;
export type GetProspectLazyQueryHookResult = ReturnType<typeof useGetProspectLazyQuery>;
export type GetProspectQueryResult = Apollo.QueryResult<GetProspectQuery, GetProspectQueryVariables>;
export const UpsertHealthInsEmployeeCensusDocument = gql`
    mutation UpsertHealthInsEmployeeCensus($employeeHealthCensus: DependentCensusInput!, $prospectId: ID!, $source: EmployeeCensusSourceEnum!) {
  upsertHealthInsEmployeeCensus(
    input: {employeeHealthCensus: $employeeHealthCensus, prospectId: $prospectId, source: $source}
  ) {
    uuids
  }
}
    `;
export type UpsertHealthInsEmployeeCensusMutationFn = Apollo.MutationFunction<UpsertHealthInsEmployeeCensusMutation, UpsertHealthInsEmployeeCensusMutationVariables>;

/**
 * __useUpsertHealthInsEmployeeCensusMutation__
 *
 * To run a mutation, you first call `useUpsertHealthInsEmployeeCensusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHealthInsEmployeeCensusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHealthInsEmployeeCensusMutation, { data, loading, error }] = useUpsertHealthInsEmployeeCensusMutation({
 *   variables: {
 *      employeeHealthCensus: // value for 'employeeHealthCensus'
 *      prospectId: // value for 'prospectId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useUpsertHealthInsEmployeeCensusMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHealthInsEmployeeCensusMutation, UpsertHealthInsEmployeeCensusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertHealthInsEmployeeCensusMutation, UpsertHealthInsEmployeeCensusMutationVariables>(UpsertHealthInsEmployeeCensusDocument, options);
      }
export type UpsertHealthInsEmployeeCensusMutationHookResult = ReturnType<typeof useUpsertHealthInsEmployeeCensusMutation>;
export type UpsertHealthInsEmployeeCensusMutationResult = Apollo.MutationResult<UpsertHealthInsEmployeeCensusMutation>;
export type UpsertHealthInsEmployeeCensusMutationOptions = Apollo.BaseMutationOptions<UpsertHealthInsEmployeeCensusMutation, UpsertHealthInsEmployeeCensusMutationVariables>;